import RoutesPrivate from "../components/routes-private";
import withLoadable from "../components/with-loadable";
import Const from "../constants";

const MisReportPage = withLoadable(() => import("../pages/root/mis-report.page"));
const DashboardLayout = withLoadable(() => import("../layouts/dashboard"));

const HelpPage = withLoadable(() => import("../pages/root/help.page"));
const DashboardPage = withLoadable(() => import("../pages/root/dashboard.page"));
const DailyWorkLogPage = withLoadable(() => import("../pages/root/daily-work-log.page"));
const ShipsPage = withLoadable(() => import("../pages/root/ships.page"));
const ViewReportsPage = withLoadable(() => import("../pages/root/view-reports.page"));
const SurveyHistoryPage = withLoadable(() => import("../pages/root/survey-history.page"));
const AddNonClassVesselPage = withLoadable(() => import("../module/add-non-class-vessel"));

const IAAuditRequestPage = withLoadable(() => import("../pages/ism-isps-mlc/audit-request.page"));
const IAActivityMonitoringDetailPage = withLoadable(() => import("../pages/ism-isps-mlc/activity-monitoring-detail.page"));
const IAActivityMonitoringPage = withLoadable(() => import("../pages/ism-isps-mlc/activity-monitoring.page"));
const IAActivityMonitoringMentoringPage = withLoadable(() => import("../pages/ism-isps-mlc/activity-monitoring-mentoring.page"));
const IAAddCertificatePage = withLoadable(() => import("../pages/ism-isps-mlc/add-certificate.page"));
const IAAddCertificateConditionalPage = withLoadable(() => import("../pages/ism-isps-mlc/add-certificate-conditional.page"));
const IAAuthorisationLetterPage = withLoadable(() => import("../pages/ism-isps-mlc/authorisation-letter.page"));
const IAAuthorisationLetterTemplatePage = withLoadable(() => import("../pages/ism-isps-mlc/authorisation-letter-template.page"));
const IACertificateDetailPage = withLoadable(() => import("../pages/ism-isps-mlc/certificate-detail.page"));
const IACertificatePage = withLoadable(() => import("../pages/ism-isps-mlc/certificate.page"));
const IAContractReviewDetailPage = withLoadable(() => import("../pages/ism-isps-mlc/contract-review-detail.page"));
const IAContractReviewPage = withLoadable(() => import("../pages/ism-isps-mlc/contract-review.page"));
const IAFormBuilderDetailPage = withLoadable(() => import("../pages/ism-isps-mlc/form-builder-detail.page"));
const IAFormBuilderPage = withLoadable(() => import("../pages/ism-isps-mlc/form-builder.page"));
const IAMyAuditsPage = withLoadable(() => import("../pages/ism-isps-mlc/my-audits.page"));
const IAPendingDocDRMyAuditsPage = withLoadable(() => import("../pages/ism-isps-mlc/pending-doc-dr-my-audits.page"));
const IAPendingAllocationPage = withLoadable(() => import("../pages/ism-isps-mlc/pending-allocation.page"));
const IAPendingDOCDRPage = withLoadable(() => import("../pages/ism-isps-mlc/pending-doc-dr.page"));
const IAPendingCertificateReviewPage = withLoadable(() => import("../pages/ism-isps-mlc/pending-certificates-reviews.page"));
const IAPendingReportPage = withLoadable(() => import("../pages/ism-isps-mlc/pending-report.page"));
const IAPendingReportPreviewPage = withLoadable(() => import("../pages/ism-isps-mlc/pending-reviews-remarks.page"));
const IACertificateReportPreviewPage = withLoadable(() => import("../pages/ism-isps-mlc/certificate-reviews-remarks.page"));
const PSCertificateReportPreviewPage = withLoadable(() => import("../pages/periodical-survey/certificate-reviews-remarks.page"));
const IAPrepareDigitalCertificatePage = withLoadable(() => import("../pages/ism-isps-mlc/prepare-digital-certificate.page"));
const RemoteAuditFormsPage = withLoadable(() => import("../pages/ism-isps-mlc/remote-audit-forms.page"));
const IASurveyPlanningPage = withLoadable(() => import("../pages/ism-isps-mlc/survey-planning.page"));
const IASurveyReportingFormPage = withLoadable(() => import("../pages/ism-isps-mlc/survey-reporting-form.page"));
const IASurveyReportingPage = withLoadable(() => import("../pages/ism-isps-mlc/survey-reporting.page"));
const IASurveyReportingReportPage = withLoadable(() => import("../pages/ism-isps-mlc/survey-reporting-report.page"));
const IAVerifyDigitalCertificatePage = withLoadable(() => import("../pages/root/verify-digital-certificate.page"));
const IANCScreen = withLoadable(() => import("../pages/ism-isps-mlc/nc-audits.page"));
const IANCClientApprovalPage = withLoadable(() => import("../pages/ism-isps-mlc/nc-survey-reporting.page"));
const IANCFormPage = withLoadable(() => import("../pages/ism-isps-mlc/nc-survey-reporting-form.page"));
const IAFlagInstructionsPage = withLoadable(() => import("../pages/ism-isps-mlc/flag-instructions.page"));
const IASurveyCallBookingForm = withLoadable(() => import("../pages/ism-isps-mlc/survey-call-booking-form.page"));
const IASurveyCallBookingPage = withLoadable(() => import("../pages/ism-isps-mlc/survey-call-booking.page"));
const IACertificateDispatchPage = withLoadable(() => import("../pages/ism-isps-mlc/dispatch-certificate.page"));
const IADispatchLetterTemplatePage = withLoadable(() => import("../pages/ism-isps-mlc/despatch-letter-template.page"));
const IARemoteSoftwarePage = withLoadable(() => import("../pages/ism-isps-mlc/remote-software.page"));
const IACompanyMasterListPage = withLoadable(() => import("../pages/ism-isps-mlc/company-master-list.page"));
const IACompanyMasterAddEditPage = withLoadable(() => import("../pages/ism-isps-mlc/company-master-detail-form.page"));
const TransferCertificatePage = withLoadable(() => import("../pages/ism-isps-mlc/transfer-certificate.page"));
const Dmlc2Page = withLoadable(() => import("../pages/ism-isps-mlc/dmlc2.page"));
const Dmlc2Details = withLoadable(() => import("../pages/ism-isps-mlc/dmlc2-details.page"));
const Dmlc2ListPage = withLoadable(() => import("../pages/ism-isps-mlc/dmlc2-listing.page"));
const TransferCertificateListPage = withLoadable(() => import("../pages/ism-isps-mlc/transfer-certificate-listing.page"));
const ValidDocPage = withLoadable(() => import("../pages/ism-isps-mlc/valid-doc-certificate.page"));

const TAWACertificateDetailPage = withLoadable(() => import("../pages/tawa/approve-certificate.page"));
const TAWACertificatePage = withLoadable(() => import("../pages/tawa/certificate.page"));
const TAWAContractPhasesDetailPage = withLoadable(() => import("../pages/tawa/contract-phases-detail.page"));
const TAWAContractPhasesFormPage = withLoadable(() => import("../pages/tawa/contract-phases-forms.page"));
const TAWAContractReviewDetailPage = withLoadable(() => import("../pages/tawa/contract-review-detail.page"));
const TAWAContractReviewPage = withLoadable(() => import("../pages/tawa/contract-review.page"));
const TAWAMyAuditsPage = withLoadable(() => import("../pages/tawa/my-audits.page"));
const TAWAPendingAllocationPage = withLoadable(() => import("../pages/tawa/pending-allocation.page"));
const TAWAPendingReportPage = withLoadable(() => import("../pages/tawa/pending-report.page"));
const TAWAPendingReportPreviewPage = withLoadable(() => import("../pages/tawa/pending-report-preview.page"));
const TAWASurveyPlanningPage = withLoadable(() => import("../pages/tawa/survey-planning.page"));
const TAWASurveyReportingPage = withLoadable(() => import("../pages/tawa/survey-reporting.page"));
const TAWASurveyReportingFormPage = withLoadable(() => import("../pages/tawa/survey-reporting-form.page"));
const TAWAAuthorisationLetterTemplatePage = withLoadable(() => import("../pages/tawa/authorisation-letter-template.page"));
const TAWASurveyReportingReportPage = withLoadable(() => import("../pages/tawa/survey-reporting-report.page"));
const TAWAAuditRequestTAPage = withLoadable(() => import("../pages/tawa/audit-request-ta.page"));
const TAWAAuditRequestWAPage = withLoadable(() => import("../pages/tawa/audit-request-wa.page"));
const TAWAAuditRequestCertificatePage = withLoadable(() => import("../pages/tawa/audit-request-certificate.page"));
const TAWAPrepareDigitalCertificatePage = withLoadable(() => import("../pages/tawa/prepare-digital-certificate.page"));
const TAWAOngoingVerificationPage = withLoadable(() => import("../pages/tawa/ongoing-verification.page"));
const TAWACertificateAmendPage = withLoadable(() => import("../pages/tawa/amend-certificate.page"));
const TAWAExistingTypeApprovalRequestPage = withLoadable(() => import("../pages/tawa/audit-request-ta.page"));
const TAWAExistingWorkApprovalRequestPage = withLoadable(() => import("../pages/tawa/audit-request-wa.page"));

const FeCustomerRequestPage = withLoadable(() => import("../pages/fe-nc/fe-construction.page"));
const FeSurveyReporting = withLoadable(() => import("../pages/fe-nc/fe-survey-reporting.page"));
const FeDataDetailsPage = withLoadable(() => import("../pages/fe-nc/fe-data-details.page"));

const TAWAOngoingVerificationPreviewPage = withLoadable(() => import("../pages/tawa/ongoing-verification-preview.page"));

const RPSContractReview = withLoadable(() => import("../pages/rps/contract-review.page"));
const RPSAcceptContractDetailPage = withLoadable(() => import("../pages/rps/contract-review-detail.page"));
const RPSAddContractDetailPage = withLoadable(() => import("../pages/rps/contract-review-request.page"));
const RPSAuthorisationLetterPage = withLoadable(() => import("../pages/rps/authorisation-letter.page"));
const RPSMyAuditPage = withLoadable(() => import("../pages/rps/my-audits.page"));
const RPSSurveyPlanningPage = withLoadable(() => import("../pages/rps/survey-planning.page"));
const RPSPendingReportPage = withLoadable(() => import("../pages/rps/pending-report.page"));
const RPSPendingAllocationPage = withLoadable(() => import("../pages/rps/pending-allocation.page"));
const RPSIAPendingReportPreviewPage = withLoadable(() => import("../pages/rps/pending-reviews-remarks.page"));
const RpsSurveyReportingPage = withLoadable(() => import("../pages/rps/survey-reporting.page"));
const RPSSurveyReportingReportPage = withLoadable(() => import("../pages/rps/survey-reporting-report.page"));
const RpsSurveyReportingFormPage = withLoadable(() => import("../pages/rps/survey-reporting-form.page"));
const RpsAuthorisationLetterTemplatePage = withLoadable(() => import("../pages/rps/authorisation-letter-template.page"));
const RpsCertificatePage = withLoadable(() => import("../pages/rps/certificate.page"));
const RpsAddCertificatePage = withLoadable(() => import("../pages/rps/add-certificate.page"));
const RpsCertificateDetailPage = withLoadable(() => import("../pages/rps/certificate-detail.page"));
const RpsPendingCertificateReviewPage = withLoadable(() => import("../pages/rps/pending-certificates-reviews.page"));
const RpsActivityMonitoringDetailPage = withLoadable(() => import("../pages/rps/activity-monitoring-detail.page"));
const RPSPrepareDigitalCertificatePage = withLoadable(() => import("../pages/rps/prepare-digital-certificate.page"));
const RPSRegisterRequestTypeForm = withLoadable(() => import("../pages/rps/audit-request.page"));
const RpsActivityMonitoringPage = withLoadable(() => import("../pages/rps/activity-monitoring.page"));
const CustomerRegisterationPage = withLoadable(() => import("../pages/root/company-registration.page"));
const CustomerRegistrationDetailPage = withLoadable(() => import("../pages/root/company-registration-detail.page"));
const RPSSuveyQualificationPage = withLoadable(() => import("../pages/rps/survey-qualification.page"));
const SSASuveyQualificationPage = withLoadable(() => import("../pages/ssa/survey-qualification.page"));

const SSAContractReviewPage = withLoadable(() => import("../pages/ssa/contract-review.page"));
const SSAAuthorisationLetterPage = withLoadable(() => import("../pages/ssa/authorisation-letter.page"));
const SSAPendingAllocationPage = withLoadable(() => import("../pages/ssa/pending-allocation.page"));
const SSAContractReviewDetailPage = withLoadable(() => import("../pages/ssa/contract-review-detail.page"));
const SSAPendingReportPage = withLoadable(() => import("../pages/ssa/pending-report.page"));
const SSAPendingReportPreviewPage = withLoadable(() => import("../pages/ssa/pending-report-preview.page"));
const SSAMyAuditsPage = withLoadable(() => import("../pages/ssa/my-audits.page"));
const SSASurveyPlanningPage = withLoadable(() => import("../pages/ssa/survey-planning.page"));
const SSACertificatePage = withLoadable(() => import("../pages/ssa/certificate.page"));
const SSASurveyReportingPage = withLoadable(() => import("../pages/ssa/survey-reporting.page"));
const SSASurveyReportingFormPage = withLoadable(() => import("../pages/ssa/survey-reporting-form.page"));
const SSASurveyReportingReportPage = withLoadable(() => import("../pages/ssa/survey-reporting-report.page"));
const SSACertificateDetailPage = withLoadable(() => import("../pages/ssa/certificate-detail.page"));
const SSAPrepareDigitalCertificatePage = withLoadable(() => import("../pages/ssa/prepare-digital-certificate.page"));
const SSAAuthorisationLetterTemplatePage = withLoadable(() => import("../pages/ssa/authorisation-letter-template.page"));
const SsaRegisterRequestForm = withLoadable(() => import("../pages/ssa/audit-request.page"));
const CaPaFeedbackPage = withLoadable(() => import("../pages/ssa/ca-pa-feedback.page"));
const CaPaFeedbackFormPage = withLoadable(() => import("../pages/ssa/ca-pa-feedback-form.page"));
const CaPaClientFeedback = withLoadable(() => import("../pages/ssa/ca-pa-client-feedback.page"));
const UploadDocumentClient = withLoadable(() => import("../pages/ssa/client-contract-review-upload-document.page"));
const UploadDocumentClientWC = withLoadable(() => import("../pages/welding-consumables/client-contract-review-upload-document.page"));

const BSAContractReviewPage = withLoadable(() => import("../pages/bsa/contract-review.page"));
const BSAPendingAllocationPage = withLoadable(() => import("../pages/bsa/pending-allocation.page"));
const BSAMyAuditsPage = withLoadable(() => import("../pages/bsa/my-audits.page"));
const BSASurveyPlanningPage = withLoadable(() => import("../pages/bsa/survey-planning.page"));
const BSASurveyReportingPage = withLoadable(() => import("../pages/bsa/survey-reporting.page"));
const BSAAuthorisationLetterPage = withLoadable(() => import("../pages/bsa/authorisation-letter.page"));
const BSAPendingReportPage = withLoadable(() => import("../pages/bsa/pending-report.page"));
const BSAAddContractDetailPage = withLoadable(() => import("../pages/bsa/contract-review-request.page"));
const BSAAuthorisationLetterTemplatePage = withLoadable(() => import("../pages/bsa/authorisation-letter-template.page"));
const BSAPendingReportPreviewPage = withLoadable(() => import("../pages/bsa/pending-report-preview.page"));
const BSASurveyReportingFormPage = withLoadable(() => import("../pages/bsa/survey-reporting-form.page"));
const BSASurveyReportingReportPage = withLoadable(() => import("../pages/bsa/survey-reporting-report.page"));
const BSACertificatePage = withLoadable(() => import("../pages/bsa/certificate.page"));
const BSAAddCertificatePage = withLoadable(() => import("../pages/bsa/add-certificate.page"));
const BSACertificateDetailPage = withLoadable(() => import("../pages/bsa/certificate-detail.page"));
const BSACertificateDuePage = withLoadable(() => import("../pages/bsa/certificate-due.page"));
const BSACertificateDueFormPage = withLoadable(() => import("../pages/bsa/certificate-due-form.page"));
const BSACompanyMasterListPage = withLoadable(() => import("../pages/bsa/company-master-list.page"));
const BSACompanyMasterAddEditPage = withLoadable(() => import("../pages/bsa/company-master-detail-form.page"));
const BSAUploadDueAuditDocumentsPage = withLoadable(() => import("../pages/bsa/upload-due-audit-documents.page"));
const BSACertificateDispatchPage = withLoadable(() => import("../pages/bsa/dispatch-certificate.page"));
const BSAActivityMonitoringPage = withLoadable(() => import("../pages/bsa/survey-qualification.page"));
const BSAActivityMonitoringDetailPage = withLoadable(() => import("../pages/bsa/activity-monitoring-detail.page"));
const BSADispatchLetterTemplatePage = withLoadable(() => import("../pages/bsa/despatch-letter-template.page"));

const ShipInspectionMyAuditsPage = withLoadable(() => import("../pages/ship-inspection/my-audits.page"));
const ShipInspectionSurveyPlanningPage = withLoadable(() => import("../pages/ship-inspection/survey-planning.page"));
const ShipInspectionSurveyReportingPage = withLoadable(() => import("../pages/ship-inspection/survey-reporting.page"));
const ShipInspectionSurveyReportingFormPage = withLoadable(() => import("../pages/ship-inspection/survey-reporting-form.page"));
const ShipInspectionSurveyReportingReportPage = withLoadable(() => import("../pages/ship-inspection/survey-reporting-report.page"));

const PCSCustomerRequestPage = withLoadable(() => import("../pages/pcs/customer-request.page"));
const PCSMyAuditPage = withLoadable(() => import("../pages/pcs/my-audits.page"));
const PCSSurveyPlanningPage = withLoadable(() => import("../pages/pcs/survey-planning.page"));
const PCSCustomerRequestAddPage = withLoadable(() => import("../pages/pcs/customer-request-form.page"));
const PCSCertificatePage = withLoadable(() => import("../pages/pcs/certificate.page"));
const PCSCertificateDetailPage = withLoadable(() => import("../pages/pcs/certificate-detail.page"));
const PCSSurveyReportingPage = withLoadable(() => import("../pages/pcs/survey-reporting.page"));
const PCSSurveyReportingReportPage = withLoadable(() => import("../pages/pcs/survey-reporting-report.page"));
const PCSSurveyReportingFormPage = withLoadable(() => import("../pages/pcs/survey-reporting-form.page"));
const PCSPendingReportPage = withLoadable(() => import("../pages/pcs/pending-report.page"));
const PCSPendingReportPreviewPage = withLoadable(() => import("../pages/pcs/pending-report-preview.page"));
const PCSPrepareDigitalCertificatePage = withLoadable(() => import("../pages/pcs/prepare-digital-certificate.page"));
const PCSPendingAllocationPage = withLoadable(() => import("../pages/pcs/pending-allocation.page"));

const PeriodicalAddRequestPage = withLoadable(() => import("../pages/periodical-survey/survey-request-add.page"));
const PeriodicalPendingAllocationPage = withLoadable(() => import("../pages/periodical-survey/pending-allocation.page"));
const PeriodicalMyAuditPage = withLoadable(() => import("../pages/periodical-survey/my-audits.page"));
const PeriodicalSurveyPlanningPage = withLoadable(() => import("../pages/periodical-survey/survey-planning.page"));
const PeriodicalSurveyPlanningNotesPage = withLoadable(() => import("../pages/periodical-survey/survey-planning-notes.page"));
const PeriodicalSurveyRequestFormPage = withLoadable(() => import("../pages/periodical-survey/survey-request-form.page"));
const PeriodicalRemoteSurveyRequestFormPage = withLoadable(() => import("../pages/periodical-survey/remote-survey-form.page"));

const PeriodicalRequestPage = withLoadable(() => import("../pages/periodical-survey/survey-request.page"));
const PeriodicalSurveyDailyReportsPage = withLoadable(() => import("../pages/periodical-survey/survey-daily-reports.page"));
const PeriodicalSurveyProgressReportsPage = withLoadable(() => import("../pages/periodical-survey/survey-progress-reports.page"));
const PeriodicalQsFormPage = withLoadable(() => import("../pages/periodical-survey/qs-form.page"));
const PeriodicalMSFormPage = withLoadable(() => import("../pages/periodical-survey/ms-form.page"));
const PeriodicalEPSFormPage = withLoadable(() => import("../pages/periodical-survey/eps-form.page"));
const PeriodicalFeFormPage = withLoadable(() => import("../pages/periodical-survey/fe-form.page"));
const PeriodicalGuidanceFormPage = withLoadable(() => import("../pages/periodical-survey/guidance-form.page"));
const PeriodicalSurveyReportingPage = withLoadable(() => import("../pages/periodical-survey/survey-reporting.page"));
const PeriodicalSurveyReportingItemUpdatePage = withLoadable(() => import("../pages/periodical-survey/survey-reporting-item-update.page"));
const PeriodicalSurveyReportingFormsNReportsListingPage = withLoadable(() => import("../pages/periodical-survey/survey-reporting-forms-reports-listing.page"));
const PeriodicalSurveyReportingFormsNReportsPage = withLoadable(() => import("../pages/periodical-survey/survey-reporting-forms-reports.page"));
const PeriodicalSurveyReportingFormPage = withLoadable(() => import("../pages/periodical-survey/survey-reporting-form.page"));
const TMPTRepairsVerificationPage = withLoadable(() => import("../pages/periodical-survey/tm-pt-repairs-verification(T7).page"));
const Fe3DataChangeRequestFormNM = withLoadable(() => import("../pages/periodical-survey/fe3-data-change-NM.page"));
const PerformanceofServiceSupplierPage = withLoadable(() => import("../pages/periodical-survey/performance-of-service-supplier-(KR)"));
const NRUploadImagePage = withLoadable(() => import("../pages/periodical-survey/nr-upload-image.page"));
const DBCReportFormPage = withLoadable(() => import("../pages/periodical-survey/dbc-report-(DB)-form.page"));
const SuppSelectionRemarksPage = withLoadable(() => import("../pages/periodical-survey/supp-selection-remarks.page"));
const PeriodicalSurveyReportReviewPage = withLoadable(() => import("../pages/periodical-survey/pending-report.page"));
const PeriodicalEHSReportListingPage = withLoadable(() => import("../pages/periodical-survey/ehs-report-listing.page"));
const PeriodicalQualificationApproval = withLoadable(() => import("../pages/periodical-survey/qualification-approval.page"));
const PeriodicalActivityMonitoringPage = withLoadable(() => import("../pages/periodical-survey/activity-monitoring.page"));
const PeriodicalActivityMonitoringDetailPage = withLoadable(() => import("../pages/periodical-survey/activity-monitoring-detail.page"));
const PeriodicalActivityMonitoringRemoteDetailPage = withLoadable(() => import("../pages/periodical-survey/activity-monitoring-remote-detail.page"));
const PeriodicalCertificatePage = withLoadable(() => import("../pages/periodical-survey/certificates.page"));
const PeriodicalPrepareFTCertificatePage = withLoadable(() => import("../pages/periodical-survey/prepare-ft-certificates.page"));
const PeriodicalPrepareDigitalCertificatePage = withLoadable(() => import("../pages/periodical-survey/prepare-digital-certificate.page"));
const PeriodicalSurveyorQualificationPage = withLoadable(() => import("../pages/periodical-survey/survey-qualification.page"));
const PeriodicalAuthorisationLetterPage = withLoadable(() => import("../pages/periodical-survey/authorisation-letter.page"));
const IccAuthorisationLetterPage = withLoadable(() => import("../pages/periodical-survey/icc-authorisation-letter.page"));
const PeriodicalOwnerLetterPage = withLoadable(() => import("../pages/periodical-survey/owner-letter.page"));
const PeriodicalRemoteSurveyAuthorisationLetterPage = withLoadable(() => import("../pages/periodical-survey/remote-survey/authorisation-letter.page"));

const ShipDetailsPage = withLoadable(() => import("../pages/root/ship-dashboard.page"));
const CertificatesAndRecordsPage = withLoadable(() => import("../pages/root/ship-dashboard.page/certificates-and-records.page"));
const JobHistoryPage = withLoadable(() => import("../pages/root/ship-dashboard.page/job-history.page"));
const PcsFsiDetentionsPage = withLoadable(() => import("../pages/root/ship-dashboard.page/pcs-fsi-detentions.page"));
const PlanStatusPage = withLoadable(() => import("../pages/root/ship-dashboard.page/plan-status.page"));
const NotesAndActionsPage = withLoadable(() => import("../pages/root/ship-dashboard.page/notes-and-actions.page"));
const CommentsPage = withLoadable(() => import("../pages/root/ship-dashboard.page/comments.page"));
const ChangeOfShipStatusPage = withLoadable(() => import("../pages/root/change-of-ship-status.page"));
const FullSchedulePage = withLoadable(() => import("../pages/root/ship-dashboard.page/full-schedule.page"));
const ShipMLItemPage = withLoadable(() => import("../pages/root/ship-dashboard.page/ml-item.page"));
const ShipViewDetailsPage = withLoadable(() => import("../pages/root/ship-dashboard.page/ship-view-details.page"));
const BlockFeePage = withLoadable(() => import("../pages/root/ship-dashboard.page/block-fee.page"));

const MiscellaneousRequestsPage = withLoadable(() => import("../pages/miscellaneous/survey-requests.page"));
const MiscellaneousRequestAddPage = withLoadable(() => import("../pages/miscellaneous/survey-request.page"));
const MiscellaneousRequestPage = withLoadable(() => import("../pages/miscellaneous/survey-request.page"));
const MLItemManageRequestsPage = withLoadable(() => import("../pages/periodical-survey/ml-item-manage-requests.page"));
const MLItemManageRequestPage = withLoadable(() => import("../pages/periodical-survey/ml-item-manage-request.page"));
const ChangeSurveyCyclePage = withLoadable(() => import("../pages/miscellaneous/change-survey-cycle.page"));
const ChangeSurveyTypePage = withLoadable(() => import("../pages/miscellaneous/change-survey-cycle.page"));
const ChangeSurveyCycleListPage = withLoadable(() => import("../pages/miscellaneous/change-survey-cycle-list.page"));
const SurveyPostponementChecklistPage = withLoadable(() => import("../pages/miscellaneous/survey-postponement-checklist.page"));
const SurveyPostponementAuthletterPage = withLoadable(() => import("../pages/miscellaneous/survey-postponement-authletter.page"));
// const PrepareDigitalAuthLetter = withLoadable(() => import("../pages/miscellaneous/prepare-digital-auth-letter.page"));
const MiscellaneousCertificatePage = withLoadable(() => import("../pages/miscellaneous/certificates.page"));
const MiscellaneousCertificatePrepareAndAmendPage = withLoadable(() => import("../pages/miscellaneous/prepare-and-amend-cert.page"));
const MiscellaneousRequestAdditionalDetailsPage = withLoadable(() => import("../pages/miscellaneous/additional-details-page"));
const ExtendCocDueDateRequestsPage = withLoadable(() => import("../pages/periodical-survey/extend-coc-due-date-requests.page"));
const ExtendCocDueDateRequestPage = withLoadable(() => import("../pages/periodical-survey/extend-coc-due-date-request.page"));
const PR17SecurityPage = withLoadable(() => import("../pages/periodical-survey/pr17-scrutiny.page"));
const PR17EditFormPage = withLoadable(() => import("../pages/periodical-survey/pr-17-edit-form.page"));
const DeleteOverdueSurveyCategoriesRequestPage = withLoadable(() => import("../pages/periodical-survey/delete-overdue-survey-categories-request.page"));
const prolongedListingPage = withLoadable(() => import("../pages/miscellaneous/prolonged-listing.page"));
const updateScopeOfClassReinstatementSurveysRequestsPage = withLoadable(() =>
  import("../pages/miscellaneous/upload-scope-of-class-reinstatement-surveys-requests.page")
);
const PSCFSIFormPage = withLoadable(() => import("../pages/periodical-survey/psc-fsi-form.page"));

const SurveyAuthorisation = withLoadable(() => import("../pages/miscellaneous/survey-authorisation.page"));
const SurveyAuthorisationRequest = withLoadable(() => import("../pages/miscellaneous/survey-authorisation-request.page"));
const SurveyAuthorisationAuthLetterPage = withLoadable(() => import("../pages/miscellaneous/survey-authorisation-auth-letter.page"));
const ProcessCheckSheetPage = withLoadable(() => import("../pages/periodical-survey/process-check-sheet-forms.page"));

const SRFARegisterRequestTypeForm = withLoadable(() => import("../pages/srfa/audit-request.page"));
const SRFAAuditRequestCertificatePage = withLoadable(() => import("../pages/srfa/audit-request-certificate.page"));
const SRFAContractReviewPage = withLoadable(() => import("../pages/srfa/contract-review.page"));
const SRFAContractReviewDetailPage = withLoadable(() => import("../pages/srfa/contract-review-detail.page"));
const SRFAAuthorisationLetterPage = withLoadable(() => import("../pages/srfa/authorisation-letter.page"));
const SRFAPendingAllocationPage = withLoadable(() => import("../pages/srfa/pending-allocation.page"));
const SRFAMyAuditPage = withLoadable(() => import("../pages/srfa/my-audits.page"));
const SRFASurveyPlanningPage = withLoadable(() => import("../pages/srfa/survey-planning.page"));
const SRFASurveyReportingPage = withLoadable(() => import("../pages/srfa/survey-reporting.page"));
const SRFASurveyReportingFormPage = withLoadable(() => import("../pages/srfa/survey-reporting-form.page"));
const SRFAPendingReportPage = withLoadable(() => import("../pages/srfa/pending-report.page"));
const SRFACertificatePage = withLoadable(() => import("../pages/srfa/certificate.page"));
const SRFACertificateSupplimentPage = withLoadable(() => import("../pages/srfa/certificate-supplyment.page"));
const SRFAPrepareDigitalCertificatePage = withLoadable(() => import("../pages/srfa/prepare-digital-certificate.page"));
const SRFACertificateDetailPage = withLoadable(() => import("../pages/srfa/certificate-detail.page"));
const SRFAActivityMonitoringPage = withLoadable(() => import("../pages/srfa/activity-monitoring.page"));
const SRFAActivityMonitoringDetailPage = withLoadable(() => import("../pages/srfa/activity-monitoring-detail.page"));
const SRFANCFormPage = withLoadable(() => import("../pages/srfa/nc-survey-reporting-form.page"));
const SRFANCAudits = withLoadable(() => import("../pages/srfa/nc-audits.page"));

const IHMSurveyRequestPage = withLoadable(() => import("../pages/ihm-rfr/survey-request.page"));
const IHMContractReviewPage = withLoadable(() => import("../pages/ihm-rfr/contract-review.page"));
const IHMContractReviewDetailsPage = withLoadable(() => import("../pages/ihm-rfr/contract-review-request.page"));
const IHMAuthorisationLetterPage = withLoadable(() => import("../pages/ihm-rfr/authorisation-letter.page"));
const IHMAuthorisationLetterTemplatePage = withLoadable(() => import("../pages/ihm-rfr/authorisation-letter-template.page"));

const ERSClientServiceRequestListingPage = withLoadable(() => import("../pages/ers/service-request-list.page"));
const ERSCustomerRequestPage = withLoadable(() => import("../pages/ers/customer-request.page"));
const ERSCustomerRequestDetailPage = withLoadable(() => import("../pages/ers/customer-request-detail.page"));
const ERSMyJobsPage = withLoadable(() => import("../pages/ers/my-jobs.page"));
const ERSPrepareAgreementPage = withLoadable(() => import("../pages/ers/prepare-agreement.page"));
const ERSAddServiceRequestPage = withLoadable(() => import("../pages/ers/add-service-request.page"));
const ERSUploadEmailsPage = withLoadable(() => import("../pages/ers/upload-emails.page"));
const ERSPrepareFtCertificatePage = withLoadable(() => import("../pages/ers/prepare-ft-certificate.page"));
const ERSServiceReportingPage = withLoadable(() => import("../pages/ers/service-reporting.page"));
const ERSReportPreviewPage = withLoadable(() => import("../pages/ers/service-reporting-form.page"));
const ERSPrepareDigitalCertificatePage = withLoadable(() => import("../pages/ers/prepare-digital-certificate.page"));
const ERSPendingReportPage = withLoadable(() => import("../pages/ers/pending-report.page"));
const ERSCertificatePage = withLoadable(() => import("../pages/ers/certificate.page"));
const ERSCertificateDetailPage = withLoadable(() => import("../pages/ers/prepare-ft-certificate.page"));
const WCContractReviewPage = withLoadable(() => import("../pages/welding-consumables/contract-review.page"));
const WCContractDetailPage = withLoadable(() => import("../pages/welding-consumables/contract-review-request.page"));
const WCAuditRequestTAPage = withLoadable(() => import("../pages/welding-consumables/audit-request-wc.page"));
const WCPendingAllocationPage = withLoadable(() => import("../pages/welding-consumables/pending-allocation.page"));
const WCMyAuditsPage = withLoadable(() => import("../pages/welding-consumables/my-audits.page"));
const WCSurveyPlanningPage = withLoadable(() => import("../pages/welding-consumables/survey-planning.page"));
const WCSurveyReportingPage = withLoadable(() => import("../pages/welding-consumables/survey-reporting.page"));
const WCPendingReportPage = withLoadable(() => import("../pages/welding-consumables/pending-report.page"));
const WCCertificatePage = withLoadable(() => import("../pages/welding-consumables/certificate.page"));
const WCCertificateDetailPage = withLoadable(() => import("../pages/welding-consumables/approve-certificate.page"));
const MTSCAPCertificatePage = withLoadable(() => import("../pages/mtscap/certificate.page"));
const MTSCAPCertificateDetailPage = withLoadable(() => import("../pages/mtscap/approve-certificate.page"));
const WCAuditRequestCertificatePage = withLoadable(() => import("../pages/welding-consumables/audit-request-certificate.page"));
const WCPrepareDigitalCertificatePage = withLoadable(() => import("../pages/welding-consumables/prepare-digital-certificate.page"));

const FEExisting = withLoadable(() => import("../pages/fe-existing"));
const WCSurveyReportingFormPage = withLoadable(() => import("../pages/welding-consumables/survey-reporting-form.page"));
const FeExistingListingPage = withLoadable(() => import("../pages/periodical-survey/fe-existing.page"));

const ESPAddRequestPage = withLoadable(() => import("../pages/esp/esp-add-request.page"));
const ESPEditRequestPage = withLoadable(() => import("../pages/esp/esp-add-request.page"));
const ESPListPage = withLoadable(() => import("../pages/esp/esp-list.page"));
const ESPAuthorisationLetterPage = withLoadable(() => import("../pages/esp/authorisation-letter.page"));
const ESPDigitalLetterPage = withLoadable(() => import("../pages/esp/prepare-digital-letter.page"));

const FEExistingRORMyAuditPageDetails = withLoadable(() => import("../pages/fe-existing-ror/component/index"));
const RemoteSurveyPageDetails = withLoadable(() => import("../pages/periodical-survey/remote-survey/index"));
const SSAActivityMonitoringDetailPage = withLoadable(() => import("../pages/ssa/activity-monitoring-detail.page"));

const MCCustomerRequestPage = withLoadable(() => import("../pages/marine-component/contract-request-form"));
const MCSSRFListPage = withLoadable(() => import("../pages/marine-component/survey-request.page"));
const MCSSurveyRequestDetailPage = withLoadable(() => import("../pages/marine-component/contract-request-form"));
const MCSPendignAllocationPage = withLoadable(() => import("../pages/marine-component/pending-allocation.page"));
const MCSMyAuditsPage = withLoadable(() => import("../pages/marine-component/my-audits.page"));
const MCSSurveyPlanningPage = withLoadable(() => import("../pages/marine-component/survey-planning.page"));
const MCSSurveyReportingPage = withLoadable(() => import("../pages/marine-component/survey-reporting.page"));
const MCSSurveyReportingFormPage = withLoadable(() => import("../pages/marine-component/survey-reporting-form.page"));
const MCSPendingReportPage = withLoadable(() => import("../pages/marine-component/pending-report.page"));
const MCSCertificatePage = withLoadable(() => import("../pages/marine-component/certificate.page"));
const MCSPrepareDigitalCertificatePage = withLoadable(() => import("../pages/marine-component/prepare-digital-certificate.page"));
const MCSSurveyorQualificationPage = withLoadable(() => import("../pages/marine-component/survey-qualification.page"));
const MCSMSFormPage = withLoadable(() => import("../pages/marine-component/ms-form.page"));
const MCSQsFormPage = withLoadable(() => import("../pages/marine-component/qs-form.page"));
const MCSActivityMonitoringPage = withLoadable(() => import("../pages/marine-component/activity-monitoring.page"));
const MCSActivityMonitoringDetailPage = withLoadable(() => import("../pages/marine-component/activity-monitoring-detail.page"));

const ManageCompaniesListingPage = withLoadable(() => import("../pages/manage companies/manage-companies-listing.page"));
const AddCompanyPage = withLoadable(() => import("../pages/manage companies/add-company.page"));
const ManageMasterPage = withLoadable(() => import("../pages/root/manage-master.page"));
const TAWASuveyQualificationPage = withLoadable(() => import("../pages/tawa/survey-qualification.page"));
const TAWASuveyQualificationDetailPage = withLoadable(() => import("../pages/tawa/survey-qualification-details.page"));
const MonthlyDGReportingPage = withLoadable(() => import("../pages/monthly-dg-reporting"));

const PFSACustomerRequestPage = withLoadable(() => import("../pages/pfsa/audit-request.page"));
const PFSAContractReviewPage = withLoadable(() => import("../pages/pfsa/contract-review.page"));
const PFSAMyAuditsPage = withLoadable(() => import("../pages/pfsa/my-audits.page"));
const PFSASurveyPlanningPage = withLoadable(() => import("../pages/pfsa/survey-planning.page"));
const PFSASurveyReportingPage = withLoadable(() => import("../pages/pfsa/survey-reporting.page"));

const ModificationConvRequestListingPage = withLoadable(() => import("../pages/periodical-survey/modification-conv-request/listing.page"));
const ModificationConvRequestEditPage = withLoadable(() => import("../pages/periodical-survey/modification-conv-request/edit.page"));
const IccPacClearanceRequestEditPage = withLoadable(() => import("../pages/periodical-survey/pac-icc-clearance.page"));
const IccPacClearanceChecklistPage = withLoadable(() => import("../pages/periodical-survey/pac-icc-clearance-checklist.page"));
const PacExclusionReasonClosurePage = withLoadable(() => import("../pages/periodical-survey/pac-exclusion-closure.page"));

const HighRisksVesselsPage = withLoadable(() => import("../pages/periodical-survey/high-risk-vessels.page"));
const PostponementExtentionMonitoringPage = withLoadable(() => import("../pages/periodical-survey/postponement-extention-monitoring"));
const InWaterSurveyPage = withLoadable(() => import("../pages/periodical-survey/inwater-survey.page"));

const NavyCustomerRequestPage = withLoadable(() => import("../pages/navy/customer-request.page"));
const NavyCustomerRequestAddPage = withLoadable(() => import("../pages/navy/cutomer-request-form.page"));
const NavyPendingAllocationPage = withLoadable(() => import("../pages/navy/pending-allocation.page"));

const SingleVoyageCustomerRequestListPage = withLoadable(() => import("../pages/single-voyage/review-request.page"));
const SingleVoyageCustomerRequestFormPage = withLoadable(() => import("../pages/single-voyage/review-request-form.page"));
const SingleVoyageCustomerRequestDetailsPage = withLoadable(() => import("../pages/single-voyage/review-request-details.page"));
const SingleVoyagePendingAllocationPage = withLoadable(() => import("../pages/single-voyage/pending-allocation.page"));
const SingleVoyageMyAuditsPage = withLoadable(() => import("../pages/single-voyage/my-audits.page"));
const SingleVoyageSurveyPlanningPage = withLoadable(() => import("../pages/single-voyage/survey-planning.page"));
const SingleVoyageSurveyReportingPage = withLoadable(() => import("../pages/single-voyage/survey-reporting.page"));
const SingleVoyageSurveyReportingFormPage = withLoadable(() => import("../pages/single-voyage/survey-reporting-form.page"));
const SingleVoyagePendingReportPage = withLoadable(() => import("../pages/single-voyage/pending-report.page"));

const NavyMyAuditsPage = withLoadable(() => import("../pages/navy/my-audits.page"));
const NavySurveyPlanningPage = withLoadable(() => import("../pages/navy/survey-planning.page"));
const NavySurveyReportingPage = withLoadable(() => import("../pages/navy/survey-reporting.page"));
const RefitDetailsFormPage = withLoadable(() => import("../pages/navy/refit-details-form.page"));
const NavyPendingReportPage = withLoadable(() => import("../pages/navy/pending-report.page"));
const NavyReportingPrepareDigitalCertificatePage = withLoadable(() => import("../pages/navy/prepare-digital-certificate.page"));

// ----------Ship Vetting Reporting-------------
const SVRSurveyRequestPage = withLoadable(() => import("../pages/ship-vetting/survey-request.page"));
const SVRSurveyRequestFormPage = withLoadable(() => import("../pages/ship-vetting/survey-request-form.page"));
const SVRSurveyPendingAllocationPage = withLoadable(() => import("../pages/ship-vetting/pending-allocation.page"));
const SVRMyJobsPage = withLoadable(() => import("../pages/ship-vetting/my-audits.page"));
const SVRSurveyPlanningPage = withLoadable(() => import("../pages/ship-vetting/survey-planning.page"));
const SVRSurveyReportingPage = withLoadable(() => import("../pages/ship-vetting/survey-reporting.page"));
const SVRSurveyReportingFormPage = withLoadable(() => import("../pages/ship-vetting/survey-reporting-form.page"));
const SVRSurveyReportingReportPage = withLoadable(() => import("../pages/ship-vetting/survey-reporting-report.page"));
const SVRPendingReportPage = withLoadable(() => import("../pages/ship-vetting/pending-report.page"));

const NavyForm0003Page = withLoadable(() => import("../pages/navy/form-0003.page"));
const ReviewPerformanceMonitoringPage = withLoadable(() => import("../pages/utilities/reviewer-performance-monitoring.page"));
const BlackWhiteGreyFlagPage = withLoadable(() => import("../pages/utilities/black-white-grey-list.page"));
const FEStatutoryDocumentCHKL = withLoadable(() => import("../pages/utilities/fe-statutory-document.page"));
const TransferClassSociet = withLoadable(() => import("../pages/utilities/transfer-class-society.page"));
const NotationsPage = withLoadable(() => import("../pages/utilities/notations.page"));
const MlItemTemplatePage = withLoadable(() => import("../pages/utilities/ml-item-templates.page"));
const MachineryElectricalOnboardActivities = withLoadable(() => import("../pages/utilities/machinery-electrical-activities.page"));
const AuditMatrix = withLoadable(() => import("../pages/utilities/iqavca-auditor-matrix.page"));
const ProcessMasterPage = withLoadable(() => import("../pages/utilities/iqavca-process-master.page"));
const ManageFieldMasterPage = withLoadable(() => import("../pages/utilities/iqavca-manage-field-master.page"));
const FocusAreaPage = withLoadable(() => import("../pages/utilities/iqavca-focus-area.page"));
const AdditionalInformationsPage = withLoadable(() => import("../pages/utilities/additional-details-page"));

const TowingPermissionAuditRequestPage = withLoadable(() => import("../pages/towing-permission/audit-request.page"));
const TowningPermissionAuditRequestListPage = withLoadable(() => import("../pages/towing-permission/contract-review.page"));
const TowningPermissionAuditRequestFormPage = withLoadable(() => import("../pages/towing-permission/contract-review-details.page"));
const TowingPermissionPendingAllocationPage = withLoadable(() => import("../pages/towing-permission/pending-allocation.page"));
const TowingPermissionMyAuditsPage = withLoadable(() => import("../pages/towing-permission/my-audits.page"));
const TowingPermissionSurveyPlanningPage = withLoadable(() => import("../pages/towing-permission/survey-planning.page"));
const TowingPermissionSurveyReportingPage = withLoadable(() => import("../pages/towing-permission/survey-reporting.page"));
const TowingPermissionSurveyReportingFormPage = withLoadable(() => import("../pages/towing-permission/survey-reporting-form.page"));
const TowingPermissionPendingReportPage = withLoadable(() => import("../pages/towing-permission/pending-report.page"));

const BuildingCertificatesMyAuditsPage = withLoadable(() => import("../pages/building-certificates/my-audits.page"));
const BuildingCertificatesSurveyPlanningPage = withLoadable(() => import("../pages/building-certificates/survey-request.page"));
const BuildingCertificatesSSClearanceFormPage = withLoadable(() => import("../pages/building-certificates/ss-clearance-form.page"));
const BuildingCertificatesCOCFormPage = withLoadable(() => import("../pages/building-certificates/coc-form.page"));
const BuildingCertificatesPendingReportPage = withLoadable(() => import("../pages/building-certificates/pending-report.page"));
const BuildingCertificatesHoClearancePage = withLoadable(() => import("../pages/building-certificates/ho-clearance.page"));
const BuildingCertificatesHoClearanceFormPage = withLoadable(() => import("../pages/building-certificates/ho-clearance-form.page"));
const BuildingCertificatesSurveyReportingPage = withLoadable(() => import("../pages/building-certificates/survey-reporting.page"));
const BuildingCertificatesSurveyRequestPage = withLoadable(() => import("../pages/building-certificates/survey-request.page"));
const BuildingCertificatesPrepareDigitalPage = withLoadable(() => import("../pages/building-certificates/prepare-digital-certificate.page"));
const BuildingCertificatesListingPage = withLoadable(() => import("../pages/building-certificates/certificate.page"));

// ----------------- MISC-X-REPORTING-ROUTES-START-----------------------------//

const MiscXReportingSurveyRequestPage = withLoadable(() => import("../pages/miscellaneous-x-reporting/customer-request.page"));
const MiscXReportingRequestAddPage = withLoadable(() => import("../pages/miscellaneous-x-reporting/customer-request-form.page"));
const MiscXReportingPendingAllocationPage = withLoadable(() => import("../pages/miscellaneous-x-reporting/pending-allocation.page"));
const MiscXReportingMyAuditsPage = withLoadable(() => import("../pages/miscellaneous-x-reporting/my-audits.page"));
const MiscXReportingSurveyPlanningPage = withLoadable(() => import("../pages/miscellaneous-x-reporting/survey-planning.page"));
const MiscXReportingSurveyReportingPage = withLoadable(() => import("../pages/miscellaneous-x-reporting/survey-reporting.page"));
const MiscXReportingReportReviewPage = withLoadable(() => import("../pages/miscellaneous-x-reporting/pending-report.page"));
const MiscXReportingSurveyReportingFormPage = withLoadable(() => import("../pages/miscellaneous-x-reporting/survey-reporting-form.page"));
const MiscXReportingSurveyForm0003Page = withLoadable(() => import("../pages/miscellaneous-x-reporting/form-0003.page"));
const MiscXReportingPrepareDigitalCertificatePage = withLoadable(() => import("../pages/miscellaneous-x-reporting/prepare-digital-certificate.page"));
const MiscXReportingReportPage = withLoadable(() => import("../pages/miscellaneous-x-reporting/survey-reporting-report.page"));

// ----------------- MISC-X-REPORTING-ROUTES-END-------------------------------//

// -----------------Damage Hull Machinery Routes --------------------------------//

const DamageHullAanlysisPage = withLoadable(() => import("../pages/damage-hull-machinery/analysis-request-form.page"));
const DamageMachineryAanlysisPage = withLoadable(() => import("../pages/damage-hull-machinery/machinery-analysis-request-form.page"));
const DamageAanlysisRequestPage = withLoadable(() => import("../pages/damage-hull-machinery/analysis-request.page"));
const DamageAanlysisReviewPage = withLoadable(() => import("../pages/damage-hull-machinery/pending-report.page"));

const MaterialTestMyAuditsPage = withLoadable(() => import("../pages/mt/my-audits.page"));
const MaterialTestSurveyPlanningPage = withLoadable(() => import("../pages/mt/survey-request.page"));
const MaterialTestSurveyEditPage = withLoadable(() => import("../pages/mt/survey-request.page"));
const MaterialTestPendingReportPage = withLoadable(() => import("../pages/mt/pending-report.page"));
const MaterialTestSurveyReportingPage = withLoadable(() => import("../pages/mt/survey-reporting.page"));
const MaterialTestSurveyForm0003Page = withLoadable(() => import("../pages/mt/form-0003.page"));
const MaterialTestSurveyReportingFormPage = withLoadable(() => import("../pages/mt/survey-reporting-form.page"));
const MaterialTestPrepareDigitalCertificatePage = withLoadable(() => import("../pages/mt/prepare-digital-certificate.page"));

// ----------------- MTSCAP-ROUTES-START-----------------------------//

const MtsCapSurveyRequestPage = withLoadable(() => import("../pages/mtscap/survey-request.page"));
const MtsCapAuthorisationLetterPage = withLoadable(() => import("../pages/mtscap/authorisation-letter.page"));
const MtsCapRequestAddPage = withLoadable(() => import("../pages/mtscap/survey-request-detail.page"));
const MtsCapPendingAllocationPage = withLoadable(() => import("../pages/mtscap/pending-allocation.page"));
const MtsCapMyAuditsPage = withLoadable(() => import("../pages/mtscap/my-audits.page"));
const MtsCapSurveyPlanningPage = withLoadable(() => import("../pages/mtscap/survey-planning.page"));
const MtsCapSurveyReportingPage = withLoadable(() => import("../pages/mtscap/survey-reporting.page"));
const MtsCapPendingReportPage = withLoadable(() => import("../pages/mtscap/pending-report.page"));
const MtsCapAuthorisationLetterTemplatePage = withLoadable(() => import("../pages/mtscap/authorisation-letter-template.page"));
const MTSCAPPrepareDigitalCertificatePage = withLoadable(() => import("../pages/mtscap/prepare-digital-certificate.page"));

// ----------------- MTSCAP-ROUTES-END-------------------------------//

// ----------------- SPECSER-ROUTES-START-----------------------------//

const SpecificationServicesMyAuditsPage = withLoadable(() => import("../pages/specser/my-audits.page"));
const SpecificationServicesPlanningPage = withLoadable(() => import("../pages/specser/survey-request.page"));
const SpecificationServicesPendingReportPage = withLoadable(() => import("../pages/specser/pending-report.page"));
const SpecificationServicesSurveyReportingPage = withLoadable(() => import("../pages/specser/survey-reporting.page"));
const SpecificationServicesForm0003Page = withLoadable(() => import("../pages/specser/form-0003.page"));
const SpecificationServicesReportingFormPage = withLoadable(() => import("../pages/specser/survey-reporting-form.page"));
const SpecificationServicesPrepareDigitalCertificatePage = withLoadable(() => import("../pages/specser/prepare-digital-certificate.page"));

// ----------------- SPECSER-ROUTES-END-------------------------------//

// ----------------- INTRNAL AUDITS-ROUTES-START-----------------------------//

const AuditPlannerListPage = withLoadable(() => import("../pages/iavc/audit-plans.page"));
const AuditPlannerDetailsPage = withLoadable(() => import("../pages/iavc/audit-plan-details.page"));
const InternalAuditsMyAuditsPage = withLoadable(() => import("../pages/iavc/my-audits.page"));
const InternalAuditsPlanningPage = withLoadable(() => import("../pages/iavc/audit-planning.page"));
const InternalAuditsReportingPage = withLoadable(() => import("../pages/iavc/audit-reporting.page"));
const InternalAuditsNoObservationPage = withLoadable(() => import("../pages/iavc/nc-observation.page"));
const InternalAuditsNCAudits = withLoadable(() => import("../pages/iavc/nc-audits.page"));
const InternalAuditsReportingFormPage = withLoadable(() => import("../pages/iavc/audit-reporting-form.page"));
const InternalAuditsPendingReportPage = withLoadable(() => import("../pages/iavc/pending-report-review.page"));
const InternalAuditsPendingMrReviewPage = withLoadable(() => import("../pages/iavc/pending-mr-review.page"));

// ----------------- INTRNAL AUDITS-ROUTES-END-------------------------------//

// ----------------- NEW CONSTRUCTION START ---------------------------------------//

const NewConstruction = withLoadable(() => import("../pages/new-construction/survey-request.page"));
const NewConstructionCustomerRequestList = withLoadable(() => import("../pages/new-construction/survey-requests.page"));
const NewConstructionContractReviewList = withLoadable(() => import("../pages/new-construction/contract-reviews.page"));
const NewConstructionPendingAllocationPage = withLoadable(() => import("../pages/new-construction/pending-allocation.page"));
const NewConstructionMyAuditPage = withLoadable(() => import("../pages/new-construction/my-audits.page"));
const NewConstructionPlanningPage = withLoadable(() => import("../pages/new-construction/survey-planning.page"));
const BlockPanelSurveyStatusPage = withLoadable(() => import("../pages/new-construction/block-panel-survey-status.page"));
const EquipmentCertificationStatusPage = withLoadable(() => import("../pages/new-construction/equipment-certification-status.page"));
const PrelaunchActivitiesChecklistPage = withLoadable(() => import("../pages/new-construction/pre-launch-checklist.page"));
const TanksSpacesSurveyStatusPage = withLoadable(() => import("../pages/new-construction/tanks-spaces-survey-status.page"));
const MachineryElectricalSurveysPage = withLoadable(() => import("../pages/new-construction/machinery-electrical-surveys.page"));
const SurveyVisitReportPage = withLoadable(() => import("../pages/new-construction/survey-visit-report.page"));
const ObservationClosurePage = withLoadable(() => import("../pages/new-construction/observation-closure.page"));
const NewConstructionPendingHoClearancePage = withLoadable(() => import("../pages/new-construction/ho-clearance.page"));
const NCPendingHoClearancePage = withLoadable(() => import("../pages/new-construction/ho-clearance-form.page"));
const NCIccClearancePage = withLoadable(() => import("../pages/new-construction/icc-clearance.page"));
// ----------------- NEW CONSTRUCTION END ---------------------------------------//

const MISReportingCustome = withLoadable(() => import("../pages/utilities/mis-custome-report.page"))

const {
  SIC,
  SIC_REG,
  SURVEYOR,
  NR,
  ISM_STAFF,
  ISPS_STAFF,
  MLC_STAFF,
  TAWA,
  TAWA_STAFF,
  RPS,
  RPS_STAFF,
  PCS,
  PCS_STAFF,
  BNK,
  BNK_STAFF,
  CLIENT,
  ISM_CLIENT,
  SSA_CLIENT,
  BSA_CLIENT,
  TAWA_CLIENT,
  WC_CLIENT,
  RPS_CLIENT,
  PERIODICAL_CLIENT,
  IHM_CLIENT,
  VOYAGE_CLIENT,
  SS_REVIEWER,
  HOR,
  ISM,
  ISPS,
  MLC,
  HOD,
  ADMIN,
  HOO,
  HOSURVEYOR,
  IA_QUALIFIED_AUDITOR,
  HODIT,
  PCS_QUALIFIED_AUDITOR,
  BSA_QUALIFIED_AUDITOR,
  RPS_QUALIFIED_AUDITOR,
  STAFF,
  PFSA,
  PFSA_STAFF,
  SSA_QUALIFIED_AUDITOR,
  TRAINING,
  HOEXAMINER,
  ESP,
  ERS,
  PS,
  TP_CLIENT,
  MXR_CLIENT,
  PAC,
  RCLSHOD,
  HOD_STAT,
  IHM,
  IHM_STAFF,
  STS,
  RM,
  HOD_HULL,
  HOD_MACH,
  AM,
  RMAS,
  QHSE,
  DH_QHSE,
  RHR,
  RNC
} = Const.ACCESS;

const TAWARoutes = [
  // NOTE: Need to conform route access for certificates
  { path: "/tawa/:approvalType/certificates", element: TAWACertificatePage },
  {
    path: "/tawa/:approvalType/certificates/:contractReviewId",
    element: TAWACertificateDetailPage,
  },
  {
    path: "/tawa/:approvalType/:contractReviewId/certificates/:certificateId",
    element: TAWACertificateAmendPage,
  },
  { path: "/tawa/certificates/:certificateId/prepare-digital", element: TAWAPrepareDigitalCertificatePage },
  { path: "/tawa/:approvalType/contract-review", element: TAWAContractReviewPage, access: [HOR, TAWA, TAWA_STAFF] },
  { path: "/tawa/:approvalType/contract-review/:contractReviewId", element: TAWAContractReviewDetailPage, access: [HOR, TAWA, TAWA_STAFF] },
  {
    path: "/tawa/:approvalType/contract-review/:contractReviewId/contract-phases",
    element: TAWAContractPhasesDetailPage,
    access: [HOR, TAWA, TAWA_STAFF],
  },
  { path: "/tawa/:approvalType/ongoing-verification/:contractReviewId/contract-phases/forms/:formId", element: TAWAContractPhasesFormPage },
  { path: "/tawa/:approvalType/my-audits", element: TAWAMyAuditsPage },
  { path: "/tawa/:approvalType/my-audits/:surveyStationId/survey-planning", element: TAWASurveyPlanningPage },
  { path: "/tawa/:approvalType/my-audits/:reportHeaderId/survey-reporting", element: TAWASurveyReportingPage },
  { path: "/tawa/:approvalType/my-audits/:reportHeaderId/survey-reporting/:formId", element: TAWASurveyReportingFormPage, access: [SURVEYOR] },
  { path: "/tawa/:approvalType/my-audits/:reportHeaderId/survey-reporting/:formId/report", element: TAWASurveyReportingReportPage, access: [SURVEYOR] },
  { path: "/tawa/:approvalType/pending-allocation", element: TAWAPendingAllocationPage },
  { path: "/tawa/:approvalType/pending-report-audit", element: TAWAPendingReportPage, elementProps: { pageFor: [ADMIN, HOD, HOR] }, access: [ADMIN, HOD, HOR] },
  { path: "/tawa/:approvalType/pending-report-audit/:contractReviewId/contract-phases/forms/:formId", element: TAWAContractPhasesFormPage, elementProps: { pageFor: [ADMIN, HOD, HOR] }, access: [ADMIN, HOD, HOR] },
  {
    path: "/tawa/:approvalType/pending-report-audit/:contractReviewId/contract-phases/forms/:formId",
    element: TAWAContractPhasesFormPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/tawa/:approvalType/pending-report-audit/:reportHeaderId/forms/:formId/preview",
    element: TAWAPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/tawa/:approvalType/pending-report-review",
    element: TAWAPendingReportPage,
    elementProps: { pageFor: [SIC, SIC_REG, SS_REVIEWER, NR] },
    access: [SIC, SIC_REG, SS_REVIEWER, NR],
  },
  { path: "/tawa/:approvalType/ongoing-verification", element: TAWAOngoingVerificationPage, elementProps: { pageFor: [] } },
  { path: "/tawa/:approvalType/ongoing-verification/:contractReviewId/contract-phases/forms/:formId", element: TAWAContractPhasesFormPage },
  {
    path: "/tawa/:approvalType/ongoing-verification-review/:reportHeaderId/forms/:formId/preview",
    element: TAWAOngoingVerificationPreviewPage,
    elementProps: { pageFor: [HOR] },
    access: [HOR],
  },
  {
    path: "/tawa/:approvalType/pending-report-review/:reportHeaderId/forms/:formId/preview",
    element: TAWAPendingReportPreviewPage,
    elementProps: { pageFor: [SIC, SIC_REG] },
    access: [SIC, SIC_REG],
  },
  { path: "/tawa/authorisation-letter-template", element: TAWAAuthorisationLetterTemplatePage, access: [TAWA, TAWA_STAFF, HOR] },
  { path: "/tawa/companies-registration", element: CustomerRegisterationPage },
  { path: "/tawa/:approvalType/surveyor-qualification", element: TAWASuveyQualificationPage, access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR] },
  {
    path: "/tawa/:approvalType/surveyor-qualification/:surveyorQualificationId",
    element: TAWASuveyQualificationDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  { path: "/tawa/mis-reports", element: MisReportPage }
];

const IARoutes = [
  { path: "/ism-isps-mlc/activity-monitoring", element: IAActivityMonitoringPage, access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR] },
  {
    path: "/ism-isps-mlc/surveyor-qualification",
    element: IAActivityMonitoringMentoringPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, TRAINING, NR],
  },
  {
    path: "/ism-isps-mlc/surveyor-qualification/:activityMonitoringId",
    element: IAActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR, TRAINING],
  },
  {
    path: "/ism-isps-mlc/surveyor-qualification/:activityMonitoringId/prepare-certificate/:formId",
    element: IAActivityMonitoringDetailPage,
    access: [SURVEYOR, CLIENT, TRAINING],
  },
  {
    path: "/ism-isps-mlc/activity-monitoring/:activityMonitoringId",
    element: IAActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  { path: "/ism-isps-mlc/authorisation-letter-template", element: IAAuthorisationLetterTemplatePage, access: [ISM_STAFF, ISPS_STAFF, MLC_STAFF, HOR] },
  { path: "/ism-isps-mlc/certificates", element: IACertificatePage },
  { path: "/ism-isps-mlc/certificates/add", element: IAAddCertificatePage },
  {
    path: "/ism-isps-mlc/certificates/add/:certificateId/conditional",
    element: IAAddCertificateConditionalPage,
  },
  { path: "/ism-isps-mlc/certificates/:certificateId", element: IACertificateDetailPage },
  {
    path: "/ism-isps-mlc/certificates/:certificateId/prepare-digital",
    element: IAPrepareDigitalCertificatePage,
  },
  {
    path: "/ism-isps-mlc/certificates/:certificateId/verify-digital",
    element: IAVerifyDigitalCertificatePage,
  },
  { path: "/ism-isps-mlc/nc-audits", element: IANCScreen, access: [CLIENT, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, ISM_STAFF, ISPS_STAFF, MLC_STAFF, NR] },
  {
    path: "/ism-isps-mlc/nc-audits/:reportHeaderId/survey-reporting",
    element: IANCClientApprovalPage,
    access: [CLIENT, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, ISM_STAFF, ISPS_STAFF, MLC_STAFF, NR],
  },
  {
    path: "/ism-isps-mlc/nc-audits/:reportHeaderId/survey-reporting/:formId",
    element: IANCFormPage,
    access: [CLIENT, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, ISM_STAFF, ISPS_STAFF, MLC_STAFF, NR],
  },
  { path: "/ism-isps-mlc/contract-review", element: IAContractReviewPage, access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC] },
  {
    path: "/ism-isps-mlc/contract-review/:contractReviewId",
    element: IAContractReviewDetailPage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC, SURVEYOR],
  },
  {
    path: "/ism-isps-mlc/contract-review/:contractReviewId/authorisation-letter",
    element: IAAuthorisationLetterPage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC],
  },
  { path: "/ism-isps-mlc/form-builder", element: IAFormBuilderPage, access: [ADMIN] },
  { path: "/ism-isps-mlc/form-builder/:formId", element: IAFormBuilderDetailPage, access: [ADMIN] },
  { path: "/ism-isps-mlc/my-audits", element: IAMyAuditsPage, access: [SURVEYOR] },
  { path: "/ism-isps-mlc/pending-doc-dr/my-audits", element: IAPendingDocDRMyAuditsPage, access: [SURVEYOR] },
  { path: "/ism-isps-mlc/my-audits/:contractReviewId/survey-planning", element: IASurveyPlanningPage, access: [SURVEYOR] },
  { path: "/ism-isps-mlc/my-audits/:reportHeaderId/survey-reporting", element: IASurveyReportingPage, access: [SURVEYOR] },
  { path: "/ism-isps-mlc/my-audits/:reportHeaderId/survey-reporting/:formId", element: IASurveyReportingFormPage, access: [SURVEYOR, CLIENT] },
  { path: "/ism-isps-mlc/my-audits/:reportHeaderId/survey-reporting/:formId/report", element: IASurveyReportingReportPage, access: [SURVEYOR, CLIENT] },
  { path: "/ism-isps-mlc/pending-allocation", element: IAPendingAllocationPage, access: [SIC, SIC_REG, NR, IA_QUALIFIED_AUDITOR] },
  { path: "/ism-isps-mlc/pending-doc-dr/pending-allocation", element: IAPendingDOCDRPage, access: [SIC, SIC_REG, NR, IA_QUALIFIED_AUDITOR] },
  { path: "/ism-isps-mlc/pending-certificates-review", element: IAPendingCertificateReviewPage, access: [HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF] },
  { path: "/ism-isps-mlc/pending-report-audit", element: IAPendingReportPage, elementProps: { pageFor: [ADMIN, HOD, HOR] }, access: [HOD, HOR] },
  {
    path: "/ism-isps-mlc/pending-report-audit/:reportHeaderId/forms/:formId/preview",
    element: IAPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/ism-isps-mlc/pending-report-review",
    element: IAPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/ism-isps-mlc/pending-report-review/:reportHeaderId/forms/:formId/preview",
    element: IAPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  { path: "/ism-isps-mlc/flag-instructions", element: IAFlagInstructionsPage, access: [ADMIN, MLC_STAFF, ISM_STAFF, ISPS_STAFF, HOD, HOR] },
  {
    path: "/survey-call-booking",
    element: IASurveyCallBookingPage,
    access: [ADMIN, HOD, HOR, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, ISM_STAFF, ISPS_STAFF, MLC_STAFF],
  },
  {
    path: "/survey-call-booking/add",
    element: IASurveyCallBookingForm,
    access: [ADMIN, HOD, HOR, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, ISM_STAFF, ISPS_STAFF, MLC_STAFF],
  },
  {
    path: "/survey-call-booking/:contractReviewId",
    element: IAContractReviewDetailPage,
    access: [ADMIN, HOD, HOR, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, ISM_STAFF, ISPS_STAFF, MLC_STAFF],
  },
  {
    path: "/ism-isps-mlc/certificates/:certificateId/certificate-dispatch",
    element: IACertificateDispatchPage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC],
  },
  {
    path: "/ism-isps/despatch-letter-template",
    element: IADispatchLetterTemplatePage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC],
  },
  {
    path: "/ism-isps-mlc/certificates/:certificateId/certificate-report-preview",
    element: IACertificateReportPreviewPage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC],
  },
  {
    path: "/ism-isps-mlc/remote-software",
    element: IARemoteSoftwarePage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC, HODIT],
  },
  {
    path: "/ism-isps-mlc/company",
    element: IACompanyMasterListPage,
    access: [ADMIN, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC],
  },
  {
    path: "/ism-isps-mlc/company/:companyId",
    element: IACompanyMasterAddEditPage,
    access: [ADMIN, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC],
  },
  {
    path: "/ism-isps-mlc/company/add",
    element: IACompanyMasterAddEditPage,
    access: [ADMIN],
  },
  {
    path: "/ism-isps-mlc/transfer-certificate/add",
    element: TransferCertificatePage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC, HODIT],
  },
  {
    path: "/ism-isps-mlc/transfer-certificate",
    element: TransferCertificateListPage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC, HODIT],
  },
  {
    path: "/ism-isps-mlc/transfer-certificate/:id",
    element: TransferCertificatePage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC, HODIT],
  },
  {
    path: "/ism-isps-mlc/dmlc-2/add",
    element: Dmlc2Page,
    access: [HOD, HOR, MLC_STAFF, MLC, HODIT],
  },
  {
    path: "/ism-isps-mlc/dmlc-2",
    element: Dmlc2ListPage,
    access: [HOD, HOR, MLC_STAFF, MLC, HODIT],
  },
  {
    path: "/ism-isps-mlc/dmlc-2/:id",
    element: Dmlc2Details,
    access: [HOD, HOR, MLC_STAFF, MLC, HODIT],
  },
  {
    path: "/ism-isps-mlc/mis-reports",
    element: MisReportPage,
  },
  {
    path: "/ism-isps-mlc/doc-list-reports",
    element: ValidDocPage,
  },
  {
    path: "/ism-isps-mlc/remote-audit-form/:contractReviewId/forms/:formId",
    element: RemoteAuditFormsPage,
  },
];

const RPSRoutes = [
  {
    path: "/rps/contract-review",
    element: RPSContractReview,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, RPS, RPS_STAFF],
  },
  {
    path: "/rps/contract-review/add",
    element: RPSAddContractDetailPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, RPS, RPS_STAFF],
  },
  {
    path: "/rps/contract-review/:contractReviewId",
    element: RPSAcceptContractDetailPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, RPS, RPS_STAFF],
  },
  {
    path: "/rps/contract-review/:contractReviewId/authorisation-letter",
    element: RPSAuthorisationLetterPage,
    access: [HOR, RPS, RPS_STAFF],
  },
  {
    path: "/rps/my-audits",
    element: RPSMyAuditPage,
    access: [SURVEYOR],
  },
  {
    path: "/rps/pending-report-review",
    element: RPSPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER, NR] },
    access: [SIC, SIC_REG, SS_REVIEWER, NR],
  },
  { path: "/rps/pending-report-audit", element: RPSPendingReportPage, elementProps: { pageFor: [ADMIN, HOD, HOR] }, access: [ADMIN, HOD, HOR] },

  { path: "/rps/my-audits/:contractReviewId/survey-planning", element: RPSSurveyPlanningPage, access: [SURVEYOR] },
  { path: "/rps/my-audits/:reportHeaderId/survey-reporting", element: RpsSurveyReportingPage, access: [SURVEYOR] },
  { path: "/rps/my-audits/:reportHeaderId/survey-reporting/:formId", element: RpsSurveyReportingFormPage, access: [SURVEYOR] },
  { path: "/rps/pending-allocation", element: RPSPendingAllocationPage, access: [SURVEYOR, SIC, SIC_REG, NR, RPS_QUALIFIED_AUDITOR] },
  {
    path: "/rps/pending-report-review/:reportHeaderId/forms/:formId/preview",
    element: RPSIAPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER, NR] },
    access: [SIC, SIC_REG, SS_REVIEWER, NR],
  },
  {
    path: "/rps/pending-report-audit/:reportHeaderId/forms/:formId/preview",
    element: RPSIAPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/rps/my-audits/:reportHeaderId/survey-reporting/:formId/report",
    element: RPSSurveyReportingReportPage,
    elementProps: { pageFor: [SURVEYOR] },
    access: [SURVEYOR],
  },
  { path: "/rps/authorisation-letter-template", element: RpsAuthorisationLetterTemplatePage, access: [RPS, RPS_STAFF, HOR] },
  { path: "/rps/certificates", element: RpsCertificatePage },
  { path: "/rps/certificates/add", element: RpsAddCertificatePage },
  { path: "/rps/certificates/:certificateId", element: RpsCertificateDetailPage },
  { path: "/rps/pending-certificates-review", element: RpsPendingCertificateReviewPage, access: [HOR, RPS, RPS_STAFF] },
  {
    path: "/rps/activity-monitoring/:activityMonitoringId",
    element: RpsActivityMonitoringDetailPage,
    access: [SIC, SURVEYOR, HOR, RPS, RPS_STAFF],
  },
  { path: "/rps/certificates/:certificateId/prepare-digital", element: RPSPrepareDigitalCertificatePage },
  { path: "/rps/activity-monitoring", element: RpsActivityMonitoringPage, access: [SIC, SURVEYOR, HOR, RPS, RPS_STAFF] },
  { path: "/rps/surveyor-qualification", element: RPSSuveyQualificationPage, access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR] },
  {
    path: "/rps/surveyor-qualification/:activityMonitoringId",
    element: RpsActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  { path: "/rps/companies-registration", element: CustomerRegisterationPage },
];

const SSARoutes = [
  {
    path: "/ssa/contract-review",
    element: SSAContractReviewPage,
    access: [HOR, SIC, SIC_REG, NR, ISM_STAFF, SURVEYOR],
  },
  {
    path: "/ssa/customer-request",
    element: SSAContractReviewPage,
    elementProps: { pageFor: [SIC, SIC_REG, NR] },
    access: [ADMIN, HOR, SIC, SIC_REG, NR, ISM_STAFF, SURVEYOR],
  },
  { path: "/ssa/pending-dr", element: SSAPendingAllocationPage, elementProps: { pendingDr: true }, access: [SIC, SIC_REG, NR, SSA_QUALIFIED_AUDITOR] },
  { path: "/ssa/pending-allocation", element: SSAPendingAllocationPage, access: [SIC, SIC_REG, NR, SSA_QUALIFIED_AUDITOR] },
  {
    path: "/ssa/contract-review/:contractReviewId/authorisation-letter",
    element: SSAAuthorisationLetterPage,
    access: [HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, SURVEYOR],
  },
  { path: "/ssa/authorisation-letter-template", element: SSAAuthorisationLetterTemplatePage, access: [ISM_STAFF, ISPS_STAFF, MLC_STAFF, HOR] },
  { path: "/ssa/certificates/:certificateId", element: SSACertificateDetailPage },
  {
    path: "/ssa/customer-request/:contractReviewId",
    element: SSAContractReviewDetailPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, ISM_STAFF, ISPS_STAFF, MLC_STAFF],
  },
  {
    path: "/ssa/contract-review/add",
    element: SSAContractReviewDetailPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, ISM_STAFF, ISPS_STAFF, MLC_STAFF],
  },
  { path: "/ssa/pending-report-audit", element: SSAPendingReportPage, elementProps: { pageFor: [ADMIN, HOD, HOR] }, access: [ADMIN, HOD, HOR] },
  {
    path: "/ssa/pending-report-audit/:reportHeaderId/forms/:formId/preview",
    element: SSAPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  { path: "/ssa/pending-report-review", element: SSAPendingReportPage, elementProps: { pageFor: [SIC, SIC_REG] }, access: [SIC, SIC_REG, SS_REVIEWER] },
  {
    path: "/ssa/pending-report-review/:reportHeaderId/forms/:formId/preview",
    element: SSAPendingReportPreviewPage,
    elementProps: { pageFor: [SIC, SIC_REG] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  { path: "/ssa/my-audits", element: SSAMyAuditsPage, elementProps: { isMyJobPage: true }, access: [SURVEYOR] },
  { path: "/ssa/my-dr-audits", element: SSAMyAuditsPage, elementProps: { drReview: true }, access: [SURVEYOR] },
  { path: "/ssa/my-audits/:contractReviewId/survey-planning", element: SSASurveyPlanningPage, access: [SURVEYOR] },
  { path: "/ssa/certificates", element: SSACertificatePage },
  { path: "/ssa/certificates/:certificateId/prepare-digital", element: SSAPrepareDigitalCertificatePage },
  { path: "/ssa/my-audits/:reportHeaderId/survey-reporting", element: SSASurveyReportingPage, access: [SURVEYOR] },
  { path: "/ssa/my-audits/:reportHeaderId/survey-reporting/:formId/:formShortCode", element: SSASurveyReportingFormPage, access: [SURVEYOR] },
  { path: "/ssa/my-audits/:reportHeaderId/survey-reporting/:formId/report", element: SSASurveyReportingReportPage, access: [SURVEYOR] },
  { path: "/ssa/companies-registration", element: CustomerRegisterationPage },
  { path: "/ssa/surveyor-qualification", element: SSASuveyQualificationPage, access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR] },
  {
    path: "/ssa/surveyor-qualification/:surveyorQualificationId",
    element: SSAActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  { path: "/ssa/mis-reports", element: MisReportPage },
  { path: "/ca-pa/ssa", element: CaPaFeedbackPage },
  { path: "/ca-pa/ssa/:feedbackId", element: CaPaFeedbackFormPage },
];

const PCSRoutes = [
  {
    path: "/pcs/customer-request",
    element: PCSCustomerRequestPage,
    access: [HOR, SIC, SURVEYOR, PCS_STAFF, ADMIN],
  },
  {
    path: "/pcs/my-audits",
    element: PCSMyAuditPage,
    access: [HOR, SIC, SURVEYOR, ADMIN],
  },
  {
    path: "/pcs/customer-request/add",
    element: PCSCustomerRequestAddPage,
    access: [HOR, SIC, SURVEYOR, PCS_STAFF, ADMIN],
  },
  {
    path: "/pcs/contract-review/:contractReviewId",
    element: PCSCustomerRequestAddPage,
    access: [HOR, SIC, SURVEYOR, PCS, PCS_STAFF],
  },
  { path: "/pcs/certificates", element: PCSCertificatePage },
  { path: "/pcs/certificates/:certificateId", element: PCSCertificateDetailPage },
  {
    path: "/pcs/pending-report-review",
    element: PCSPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER, NR] },
    access: [SIC, SIC_REG, SS_REVIEWER, NR],
  },
  {
    path: "/pcs/pending-report-review/:reportHeaderId/forms/:formId/preview",
    element: PCSPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER, NR] },
    access: [SIC, SIC_REG, SS_REVIEWER, NR],
  },
  {
    path: "/pcs/pending-report-audit",
    element: PCSPendingReportPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/pcs/pending-report-audit/:reportHeaderId/forms/:formId/preview",
    element: PCSPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  { path: "/pcs/my-audits/:contractReviewId/survey-planning", element: PCSSurveyPlanningPage, access: [SURVEYOR] },
  { path: "/pcs/my-audits/:reportHeaderId/survey-reporting", element: PCSSurveyReportingPage, access: [SURVEYOR] },
  { path: "/pcs/my-audits/:reportHeaderId/survey-reporting/:formId/report", element: PCSSurveyReportingReportPage, access: [SURVEYOR] },
  { path: "/pcs/my-audits/:reportHeaderId/survey-reporting/:formId", element: PCSSurveyReportingFormPage, access: [SURVEYOR] },
  { path: "/pcs/certificates/:certificateId/prepare-digital", element: PCSPrepareDigitalCertificatePage },
  { path: "/pcs/pending-allocation", element: PCSPendingAllocationPage, access: [SURVEYOR, SIC, SIC_REG, NR, PCS_QUALIFIED_AUDITOR] },
  { path: "/pcs/companies-registration", elementProps: { is_pcs_company: true }, element: CustomerRegisterationPage },
];

const BSARoutes = [
  {
    path: "/bsa/contract-review",
    element: BSAContractReviewPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  {
    path: "/bsa/due-audits",
    element: BSACertificateDuePage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  {
    path: "/bsa/contract-review/:contractReviewId",
    element: BSAAddContractDetailPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  {
    path: "/bsa/due-audits/:companyId",
    element: BSACertificateDueFormPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  { path: "/bsa/pending-allocation", element: BSAPendingAllocationPage, access: [SIC, SIC_REG, NR, BSA_QUALIFIED_AUDITOR] },
  { path: "/bsa/my-audits", element: BSAMyAuditsPage, access: [SURVEYOR] },
  { path: "/bsa/my-audits/:contractReviewId/survey-planning", element: BSASurveyPlanningPage, access: [SURVEYOR] },
  { path: "/bsa/my-audits/:reportHeaderId/survey-reporting", element: BSASurveyReportingPage, access: [SURVEYOR] },
  { path: "/bsa/my-audits/:reportHeaderId/survey-reporting/:formId", element: BSASurveyReportingFormPage, access: [SURVEYOR] },
  {
    path: "/bsa/pending-report-review",
    element: BSAPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER, NR] },
    access: [SIC, SIC_REG, SS_REVIEWER, NR],
  },
  { path: "/bsa/my-audits/:reportHeaderId/survey-reporting/:formId/report", element: BSASurveyReportingReportPage, access: [SURVEYOR] },
  {
    path: "/bsa/contract-review/:contractReviewId/authorisation-letter",
    element: BSAAuthorisationLetterPage,
    access: [HOR, BNK, BNK_STAFF],
  },
  { path: "/bsa/pending-report-audit", element: BSAPendingReportPage, elementProps: { pageFor: [ADMIN, HOD, HOR] }, access: [ADMIN, HOD, HOR] },
  {
    path: "/bsa/pending-report-audit/:reportHeaderId/forms/:formId/preview",
    element: BSAPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/bsa/pending-report-review/:reportHeaderId/forms/:formId/preview",
    element: BSAPendingReportPreviewPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/bsa/contract-review/add",
    element: BSAAddContractDetailPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  { path: "/bsa/certificates", element: BSACertificatePage },
  { path: "/bsa/certificates/add", element: BSAAddCertificatePage },
  {
    path: "/bsa/certificates/:certificateId",
    element: BSACertificateDetailPage,
    access: [ADMIN, HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  {
    path: "/bsa/authorisation-letter-template",
    element: BSAAuthorisationLetterTemplatePage,
    access: [BNK, BNK_STAFF, HOR],
  },
  {
    path: "/bsa/company",
    element: BSACompanyMasterListPage,
    access: [ADMIN],
  },
  {
    path: "/bsa/company/:companyId",
    element: BSACompanyMasterAddEditPage,
    access: [ADMIN],
  },
  {
    path: "/bsa/company/add",
    element: BSACompanyMasterAddEditPage,
    access: [ADMIN],
  },
  { path: "/audit-request/bsa", element: BSAUploadDueAuditDocumentsPage, access: [BSA_CLIENT] },
  {
    path: "/bsa/certificates/:certificateId/certificate-dispatch",
    element: BSACertificateDispatchPage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC, BNK_STAFF],
  },
  {
    path: "/audit-request/bsa",
    element: BSAUploadDueAuditDocumentsPage,
    access: [BSA_CLIENT],
  },
  { path: "/bsa/surveyor-qualification", element: BSAActivityMonitoringPage, access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR] },
  {
    path: "/bsa/surveyor-qualification/:activityMonitoringId",
    element: BSAActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  { path: "/bsa/companies-registration", elementProps: { is_bsa_company: true }, element: CustomerRegisterationPage },
  { path: "/bsa/mis-reports", element: MisReportPage },
  {
    path: "/bsa/despatch-letter-template",
    element: BSADispatchLetterTemplatePage,
    access: [ADMIN],
  },
];

const SRFARoutes = [
  {
    path: "/srfa/contract-review",
    element: SRFAContractReviewPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  {
    path: "/srfa/contract-review/:contractReviewId",
    element: SRFAContractReviewDetailPage,
    access: [HOD, HOR, SURVEYOR],
  },
  {
    path: "/srfa/contract-review/:contractReviewId/authorisation-letter",
    element: SRFAAuthorisationLetterPage,
    access: [HOD, HOR],
  },
  { path: "/srfa/pending-allocation", element: SRFAPendingAllocationPage, access: [SURVEYOR] },
  {
    path: "/srfa/my-audits",
    element: SRFAMyAuditPage,
    access: [HOR, SIC, SURVEYOR, ADMIN],
  },
  { path: "/srfa/my-audits/:contractReviewId/survey-planning", element: SRFASurveyPlanningPage, access: [SURVEYOR] },
  { path: "/srfa/my-audits/:reportHeaderId/survey-reporting", element: SRFASurveyReportingPage, access: [SURVEYOR] },
  { path: "/srfa/my-audits/:reportHeaderId/survey-reporting/:formId", element: SRFASurveyReportingFormPage, access: [SURVEYOR] },
  {
    path: "/srfa/pending-report-review",
    element: SRFAPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  { path: "/srfa/pending-report-audit", element: SRFAPendingReportPage, elementProps: { pageFor: [ADMIN, HOD, HOR] }, access: [HOD, HOR] },
  { path: "/srfa/certificates", element: SRFACertificatePage },
  { path: "/srfa/certificates/:reportHeaderId/suppliments/:formId", element: SRFACertificateSupplimentPage },
  { path: "/srfa/certificates/:certificateId/prepare-digital", element: SRFAPrepareDigitalCertificatePage },
  { path: "/srfa/certificates/:certificateId", element: SRFACertificateDetailPage },
  { path: "/srfa/activity-monitoring", element: SRFAActivityMonitoringPage, access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR] },
  { path: "/srfa/pending-dr", element: SRFAPendingAllocationPage, elementProps: { pendingDr: true }, access: [SIC, SIC_REG, NR] },
  { path: "/srfa/my-dr-audits", element: SRFAMyAuditPage, elementProps: { pendingDr: true }, access: [SURVEYOR] },
  {
    path: "/srfa/activity-monitoring/:activityMonitoringId",
    element: SRFAActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  { path: "/srfa/nc-audits", element: SRFANCAudits, access: [CLIENT, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, ISM_STAFF, ISPS_STAFF, MLC_STAFF, NR] },
  {
    path: "/srfa/nc-audits/:reportHeaderId/survey-reporting/:formId",
    element: SRFANCFormPage,
    access: [CLIENT, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, ISM_STAFF, ISPS_STAFF, MLC_STAFF, NR],
  },
];

const ShipInspectionRoutes = [
  { path: "/ship-inspection/my-audits", element: ShipInspectionMyAuditsPage, access: [SURVEYOR] },
  { path: "/ship-inspection/my-audits/:reportHeaderId/survey-planning", element: ShipInspectionSurveyPlanningPage, access: [SURVEYOR] },
  { path: "/ship-inspection/my-audits/:reportHeaderId/survey-reporting", element: ShipInspectionSurveyReportingPage, access: [SURVEYOR] },
  { path: "/ship-inspection/my-audits/:reportHeaderId/survey-reporting/:formId", element: ShipInspectionSurveyReportingFormPage, access: [SURVEYOR] },
  { path: "/ship-inspection/my-audits/:reportHeaderId/survey-reporting/:formId/report", element: ShipInspectionSurveyReportingReportPage, access: [SURVEYOR] },
];

const PeriodicalSurveyRoutes = [
  {
    path: "/periodical-survey/surveyor-qualification",
    element: PeriodicalSurveyorQualificationPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical-survey/surveyor-qualification/:employeeCode/approval",
    element: PeriodicalQsFormPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical-survey/mentoring-survey",
    element: PeriodicalMSFormPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical-survey/qualification-survey",
    element: PeriodicalQsFormPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical-survey/activity-monitoring",
    element: PeriodicalActivityMonitoringPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical-survey/activity-monitoring/:activityMonitoringId",
    element: PeriodicalActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical-survey/activity-monitoring/add",
    element: PeriodicalActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical-survey/activity-monitoring-remote/:activityMonitoringId",
    element: PeriodicalActivityMonitoringRemoteDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical-survey/activity-monitoring-remote/add",
    element: PeriodicalActivityMonitoringRemoteDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical/customer-request",
    element: PeriodicalRequestPage,
    access: [ADMIN, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR, STAFF],
  },
  {
    path: "/periodical/survey-request/:SRFId",
    element: PeriodicalAddRequestPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR],
  },
  {
    path: "/periodical/add-customer-request",
    element: PeriodicalAddRequestPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/periodical/my-audits/:id/survey-planning",
    element: PeriodicalSurveyPlanningPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/notes",
    element: PeriodicalSurveyPlanningNotesPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/periodical/my-audits/:surveyRequestId/survey-planning/:visitId/survey-daily-reports",
    element: PeriodicalSurveyDailyReportsPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR],
  },
  {
    path: "/periodical/my-audits/:surveyRequestId/survey-planning/:visitId/survey-progress-reports",
    element: PeriodicalSurveyProgressReportsPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR],
  },
  { path: "/periodical/pending-allocation", element: PeriodicalPendingAllocationPage, access: [ADMIN, SURVEYOR, SIC, SIC_REG, NR] },
  {
    path: "/periodical/my-audits",
    element: PeriodicalMyAuditPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting",
    element: PeriodicalSurveyReportingPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/:surveyCategoryId/item-update",
    element: PeriodicalSurveyReportingItemUpdatePage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/forms-reports/list",
    element: PeriodicalSurveyReportingFormsNReportsListingPage,
    access: [ADMIN, HOR, SIC, SURVEYOR, RHR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/forms-reports",
    element: PeriodicalSurveyReportingFormsNReportsPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/forms-reports/:formId",
    element: PeriodicalSurveyReportingFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR, STAFF],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/forms-reports/tm-pt-repairs-verification/:formId",
    element: TMPTRepairsVerificationPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/forms-reports/fe3-data-change/:formId",
    element: Fe3DataChangeRequestFormNM,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/forms-reports/performance-of-service-supplier/:formId",
    element: PerformanceofServiceSupplierPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/forms-reports/narrative-report/:formId",
    element: NRUploadImagePage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/forms-reports/dbc-report/:formId",
    element: DBCReportFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/forms-reports/form-selection",
    element: SuppSelectionRemarksPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/qs/:employeeCode",
    element: PeriodicalQsFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/qs",
    element: PeriodicalQsFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/ms/:employeeCode",
    element: PeriodicalMSFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/ms",
    element: PeriodicalMSFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/esp_reports/:formId",
    element: PeriodicalEPSFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/Fe_reports/:formCode",
    element: PeriodicalFeFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/my-audits/:reportHeaderId/survey-reporting/guidance",
    element: PeriodicalGuidanceFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/periodical/pending-report-audit",
    element: PeriodicalSurveyReportReviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/periodical/pending-report-review",
    element: PeriodicalSurveyReportReviewPage,
    elementProps: { pageFor: [SIC, SIC_REG] },
    access: [ADMIN, HOO, SIC, SIC_REG, SS_REVIEWER, NR],
  },
  {
    path: "/periodical/qualification-approval",
    element: PeriodicalQualificationApproval,
    elementProps: { pageFor: [SIC, SIC_REG] },
    access: [ADMIN, SIC, SIC_REG, HOO],
  },
  {
    path: "/periodical/qualification-surveys/:reportHeaderId/approval/:employeeCode/:isapproval",
    element: PeriodicalQsFormPage,
    elementProps: { pageFor: [SIC, SIC_REG] },
    access: [ADMIN, SIC, HOO, SIC_REG],
  },
  { path: "/periodical/certificates", element: PeriodicalCertificatePage, access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR, STAFF] },
  {
    path: "/periodical/prepare-ft-certificates",
    element: PeriodicalPrepareFTCertificatePage,
    access: [ADMIN, HOD, HOR, PS, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, STAFF],
  },
  {
    path: "/periodical/certificates/:certificateId/prepare-digital",
    element: PeriodicalPrepareDigitalCertificatePage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR, PS, STAFF],
  },
  {
    path: "/periodical/survey-request/:requestId/authorisation-letter",
    element: PeriodicalAuthorisationLetterPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical/survey-request/:requestId/icc-authorisation-letter",
    element: IccAuthorisationLetterPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical/survey-request/:requestId/owner-letter",
    element: PeriodicalOwnerLetterPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical/remote-survey/:requestId/authorisation-letter",
    element: PeriodicalRemoteSurveyAuthorisationLetterPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/periodical/ehs-report-review",
    element: PeriodicalEHSReportListingPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/periodical/certificates/:certificateId/certificate-report-preview",
    element: PSCertificateReportPreviewPage,
    access: [HOD, HOR, ISM_STAFF, ISPS_STAFF, MLC_STAFF, ISM, ISPS, MLC],
  },
  { path: "/periodical/survey-authorisation", element: SurveyAuthorisation, access: [HOO, SURVEYOR] },
  { path: "/periodical/survey-authorisation/add", element: SurveyAuthorisationRequest, access: [HOO, SURVEYOR] },
  { path: "/periodical/survey-authorisation/:SRFId", element: SurveyAuthorisationRequest, access: [HOO, SURVEYOR] },
  {
    path: "/periodical/survey-authorisation/:requestId/authorisation-letter",
    element: SurveyAuthorisationAuthLetterPage,
    access: [ADMIN, HOO],
  },
  {
    path: "/periodical/survey-request/:surveyRequestId/process-sheet/:formId",
    element: ProcessCheckSheetPage,
    access: [ADMIN, HOO, PS],
  },
];

const FirstEntryExistingSurveyRoutes = [
  {
    path: "/first-entry-existing/pending-allocation",
    element: PeriodicalPendingAllocationPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, SURVEYOR, SIC, SIC_REG, NR],
  },
  {
    path: "/first-entry-existing/my-audits",
    element: PeriodicalMyAuditPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/first-entry-existing/my-audits/:id/survey-planning",
    element: PeriodicalSurveyPlanningPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/notes",
    element: PeriodicalSurveyPlanningNotesPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/first-entry-existing/my-audits/:surveyRequestId/survey-planning/:visitId/survey-daily-reports",
    element: PeriodicalSurveyDailyReportsPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR],
  },
  {
    path: "/first-entry-existing/my-audits/:surveyRequestId/survey-planning/:visitId/survey-progress-reports",
    element: PeriodicalSurveyProgressReportsPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting",
    element: PeriodicalSurveyReportingPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/:surveyCategoryId/item-update",
    element: PeriodicalSurveyReportingItemUpdatePage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/forms-reports/list",
    element: PeriodicalSurveyReportingFormsNReportsListingPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR, RHR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/forms-reports",
    element: PeriodicalSurveyReportingFormsNReportsPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/forms-reports/:formId",
    element: PeriodicalSurveyReportingFormPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR, STAFF],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/forms-reports/tm-pt-repairs-verification/:formId",
    element: TMPTRepairsVerificationPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/forms-reports/fe3-data-change/:formId",
    element: Fe3DataChangeRequestFormNM,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/forms-reports/performance-of-service-supplier/:formId",
    element: PerformanceofServiceSupplierPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/forms-reports/narrative-report/:formId",
    element: NRUploadImagePage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/forms-reports/dbc-report/:formId",
    element: DBCReportFormPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/forms-reports/form-selection",
    element: SuppSelectionRemarksPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/qs/:employeeCode",
    element: PeriodicalQsFormPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/qs",
    element: PeriodicalQsFormPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/ms/:employeeCode",
    element: PeriodicalMSFormPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/ms",
    element: PeriodicalMSFormPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/esp_reports/:formId",
    element: PeriodicalEPSFormPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/Fe_reports/:formCode",
    element: PeriodicalFeFormPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/my-audits/:reportHeaderId/survey-reporting/guidance",
    element: PeriodicalGuidanceFormPage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/first-entry-existing/pending-report-audit",
    element: PeriodicalSurveyReportReviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR], isFeNoClassed: true },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/first-entry-existing/pending-report-review",
    element: PeriodicalSurveyReportReviewPage,
    elementProps: { pageFor: [SIC, SIC_REG], isFeNoClassed: true },
    access: [ADMIN, SIC, SIC_REG, NR],
  },
  {
    path: "/first-entry-existing/qualification-approval",
    element: PeriodicalQualificationApproval,
    elementProps: { pageFor: [SIC, SIC_REG], isFeNoClassed: true },
    access: [ADMIN, SIC, SIC_REG, HOO],
  },
  {
    path: "/first-entry-existing/qualification-surveys/:reportHeaderId/approval/:employeeCode/:isapproval",
    element: PeriodicalQsFormPage,
    elementProps: { pageFor: [SIC, SIC_REG], isFeNoClassed: true },
    access: [ADMIN, SIC, HOO, SIC_REG],
  },
  {
    path: "/first-entry-existing/certificates",
    element: PeriodicalCertificatePage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR, STAFF]
  },
  {
    path: "/first-entry-existing/prepare-ft-certificates",
    element: PeriodicalPrepareFTCertificatePage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOD, HOR, PS, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, STAFF],
  },
  {
    path: "/first-entry-existing/certificates/:certificateId/prepare-digital",
    element: PeriodicalPrepareDigitalCertificatePage,
    elementProps: { isFeNoClassed: true },
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR, PS, STAFF],
  },

];

const NewConstructionSurveyRoutes = [
  {
    path: "/new-construction/customer-request",
    element: NewConstructionCustomerRequestList,
    access: [ADMIN, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR, STAFF],
  },
  {
    path: "/new-construction/client-requests",
    element: NewConstructionContractReviewList,
    access: [CLIENT],
    elementProps: { pageFor: { isClient: true } },
  },
  {
    path: "/new-construction/contract-review",
    element: NewConstructionContractReviewList,
    access: [ADMIN, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR, STAFF],
  },
  {
    path: "/new-construction/pending-allocation",
    element: NewConstructionPendingAllocationPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/new-construction/my-audits",
    element: NewConstructionMyAuditPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/new-construction/my-audits/:id/survey-planning",
    element: NewConstructionPlanningPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/new-construction/my-audits/:surveyRequestId/survey-planning/tank-space-survey-status",
    element: TanksSpacesSurveyStatusPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/new-construction/my-audits/:surveyRequestId/survey-planning/block-panel-survey-status",
    element: BlockPanelSurveyStatusPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/new-construction/my-audits/:surveyRequestId/survey-planning/equipment-certification-status",
    element: EquipmentCertificationStatusPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/new-construction/my-audits/:surveyRequestId/survey-planning/machinery-electrical-surveys",
    element: MachineryElectricalSurveysPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/new-construction/my-audits/:surveyRequestId/survey-planning/:visitId/survey-visit-reports",
    element: SurveyVisitReportPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR],
  },
  {
    path: "/new-construction/my-audits/:surveyRequestId/survey-planning/observation-closure",
    element: ObservationClosurePage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR],
  },
  {
    path: "/new-construction/my-audits/:surveyRequestId/survey-planning/prelaunch-activities-checklists",
    element: PrelaunchActivitiesChecklistPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting",
    element: PeriodicalSurveyReportingPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/:surveyCategoryId/item-update",
    element: PeriodicalSurveyReportingItemUpdatePage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/forms-reports",
    element: PeriodicalSurveyReportingFormsNReportsPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/forms-reports/:formId",
    element: PeriodicalSurveyReportingFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR, STAFF],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/forms-reports/tm-pt-repairs-verification/:formId",
    element: TMPTRepairsVerificationPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/forms-reports/fe3-data-change/:formId",
    element: Fe3DataChangeRequestFormNM,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/forms-reports/performance-of-service-supplier/:formId",
    element: PerformanceofServiceSupplierPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/forms-reports/narrative-report/:formId",
    element: NRUploadImagePage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/forms-reports/form-selection",
    element: SuppSelectionRemarksPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/qs/:employeeCode",
    element: PeriodicalQsFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/qs",
    element: PeriodicalQsFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/ms/:employeeCode",
    element: PeriodicalMSFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/ms",
    element: PeriodicalMSFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/esp_reports/:formId",
    element: PeriodicalEPSFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/Fe_reports/:formCode",
    element: PeriodicalFeFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/my-audits/:reportHeaderId/survey-reporting/guidance",
    element: PeriodicalGuidanceFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/new-construction/pending-report-audit",
    element: PeriodicalSurveyReportReviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/new-construction/fe-pending-report-audit",
    element: PeriodicalSurveyReportReviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR], isFeNoClassed: true },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/new-construction/pending-report-review",
    element: PeriodicalSurveyReportReviewPage,
    elementProps: { pageFor: [SIC, SIC_REG] },
    access: [ADMIN, SIC, SIC_REG, NR],
  },
  {
    path: "/new-construction/pending-ho-clearance",
    element: NewConstructionPendingHoClearancePage,
    elementProps: { pageFor: [ADMIN, HOD, HOR, PAC] },
    access: [ADMIN, PAC],
  },
  {
    path: "/new-construction/prelaunch-clearance/:surveyRequestId",
    element: NCPendingHoClearancePage,
    elementProps: { pageFor: [ADMIN, HOD, HOR, PAC] },
    access: [ADMIN, PAC],
  },
  {
    path: "/new-construction/icc-clearance/:surveyRequestId",
    element: NCIccClearancePage,
    elementProps: { pageFor: [ADMIN, HOD, HOR, PAC] },
    access: [ADMIN, PAC],
  },
  { path: "/new-construction/certificates", element: PeriodicalCertificatePage, access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR, STAFF] },
  {
    path: "/new-construction/prepare-ft-certificates",
    element: PeriodicalPrepareFTCertificatePage,
    access: [ADMIN, HOD, HOR, PS, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, STAFF],
  },
  {
    path: "/new-construction/certificates/:certificateId/prepare-digital",
    element: PeriodicalPrepareDigitalCertificatePage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR, PS, STAFF],
  },
  {
    path: "/new-construction/pending-report-audit",
    element: PeriodicalSurveyReportReviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR], isNewConstructionSurvey: true },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/new-construction/pending-report-review",
    element: PeriodicalSurveyReportReviewPage,
    elementProps: { pageFor: [SIC, SIC_REG], isNewConstructionSurvey: true },
    access: [ADMIN, SIC, SIC_REG, NR],
  },
];

const IHMRoutes = [
  {
    path: "/ihm-rfr/:requestType/contract-review",
    element: IHMContractReviewPage,
    access: [ADMIN, HOD, HOR, CLIENT, IHM, IHM_STAFF],
  },
  {
    path: "/ihm-rfr/:requestType/contract-review/:contractReviewId",
    element: IHMContractReviewDetailsPage,
    access: [ADMIN, HOD, HOR, IHM, IHM_STAFF],
  },
  {
    path: "/ihm-rfr/:requestType/authorisation-letter-template",
    element: IHMAuthorisationLetterTemplatePage,
    access: [ADMIN, HOD, HOR, IHM, IHM_STAFF],
  },
  {
    path: "/ihm-rfr/:requestType/contract-review/:contractReviewId/authorisation-letter",
    element: IHMAuthorisationLetterPage,
    access: [ADMIN, HOD, HOR, IHM, IHM_STAFF],
  },
];

const RequestFormsRoutes = [
  { path: "/audit-request/tawa/:approvalType/certificate", element: TAWAAuditRequestCertificatePage, access: [TAWA_CLIENT] },
  { path: "/audit-request/tawa/wa/:companyId", element: TAWAAuditRequestWAPage, access: [TAWA_CLIENT] },
  { path: "/audit-request/tawa/ta/:companyId", element: TAWAAuditRequestTAPage, access: [TAWA_CLIENT] },
  { path: "/audit-request/tawa/ta/:companyId/contract-review/:contractId", element: TAWAExistingTypeApprovalRequestPage, access: [TAWA_CLIENT] },
  { path: "/audit-request/tawa/wa/:companyId/contract-review/:contractId", element: TAWAExistingWorkApprovalRequestPage, access: [TAWA_CLIENT] },
  { path: "/audit-request/tawa/ta", element: TAWAAuditRequestTAPage, access: [TAWA_CLIENT] },
  { path: "/audit-request/tawa/wa", element: TAWAAuditRequestWAPage, access: [TAWA_CLIENT] },
  { path: "/audit-request/:type", element: IAAuditRequestPage, access: [ISM_CLIENT, ADMIN, CLIENT] },
  { path: "/audit-request/rps", element: RPSRegisterRequestTypeForm, access: [RPS_CLIENT] },
  { path: "/audit-request/ssa", element: SsaRegisterRequestForm, access: [SSA_CLIENT] },
  { path: "/audit-request/towing-permission", element: TowingPermissionAuditRequestPage, access: [TP_CLIENT] },
  { path: "/towing-permission/survey-requests", element: TowningPermissionAuditRequestFormPage, access: [ADMIN, CLIENT, TP_CLIENT] },

  { path: "/ca-pa/ssa", element: CaPaFeedbackPage },
  { path: "/capa-feedback/ssa", element: CaPaClientFeedback },
  { path: "/client-upload-document/ssa", element: UploadDocumentClient, access: [SSA_CLIENT] },
  { path: "/client-upload-document/wc", element: UploadDocumentClientWC, access: [WC_CLIENT] },
  { path: "/survey-request/periodical", element: PeriodicalSurveyRequestFormPage, access: [PERIODICAL_CLIENT, ADMIN, CLIENT] },
  { path: "/remote-survey-request/periodical/:id?", element: PeriodicalRemoteSurveyRequestFormPage, access: [PERIODICAL_CLIENT, ADMIN, HOD, HOR, SURVEYOR] },

  { path: "/audit-request/srfa", element: SRFARegisterRequestTypeForm },
  { path: "/audit-request/srfa/certificate", element: SRFAAuditRequestCertificatePage, access: [CLIENT] },
  { path: "/survey-request/ihm-rfr", element: IHMSurveyRequestPage, access: [IHM_CLIENT] },
  { path: "/service-request/ers", element: ERSClientServiceRequestListingPage },
  { path: "/ers/:irNo/service-request", element: ERSAddServiceRequestPage },
  { path: "/mcs/service-request", element: MCCustomerRequestPage },
  { path: "/survey-request/ers/non-classed", element: ERSAddServiceRequestPage },
  { path: "/audit-request/wc/certificate", element: WCAuditRequestCertificatePage, access: [WC_CLIENT] },
  { path: "/fe-request/fe-existing/:surveyRequestFor?", element: FEExisting, access: [CLIENT] },
  { path: "/new-construction-request", element: NewConstruction, access: [CLIENT] },
  { path: "/survey-request/voyage", element: SingleVoyageCustomerRequestFormPage, access: [ADMIN, CLIENT, VOYAGE_CLIENT] },
];

const feRoutes = [
  { path: "/fe/customer-request", element: FeCustomerRequestPage, access: [HOR, HOD, ADMIN, SURVEYOR] },
  { path: "/fe/customer-request/:projectId", element: FeSurveyReporting, access: [HOR, HOD, ADMIN, SURVEYOR] },
  { path: "/fe/fe-data-details/:irNo", element: FeDataDetailsPage, access: [HOR, HOD, ADMIN] },
];

const shipDetailsRoutes = [
  { path: "/ships/:irNo/dashboard", element: ShipDetailsPage },
  { path: "/ships/:irNo/view-details", element: ShipViewDetailsPage },
  { path: "/ships/:irNo/certificates-and-records", element: CertificatesAndRecordsPage },
  { path: "/ships/:irNo/job-history", element: JobHistoryPage },
  { path: "/ships/:irNo/psc-fsi-detentions", element: PcsFsiDetentionsPage },
  { path: "/ships/:irNo/plan-status", element: PlanStatusPage },
  { path: "/ships/:irNo/notes-and-actions", element: NotesAndActionsPage },
  { path: "/ships/:irNo/comments", element: CommentsPage },
  { path: "/ships/:irNo/change-of-ship-status", element: ChangeOfShipStatusPage },
  { path: "/ships/:irNo/full-schedule", element: FullSchedulePage },
  { path: "/ships/:irNo/ml-item-update", element: ShipMLItemPage },
  { path: "/ships/:irNo/ml-item-update/:surveyCategoryId", element: PeriodicalSurveyReportingItemUpdatePage },
  { path: "/ships/:irNo/fe-reports/:formCode", element: PeriodicalFeFormPage },
  { path: "/ships/:irNo/block-fee", element: BlockFeePage },
];

const miscellaneousRoutes = [
  { path: "/miscellaneous/requests", element: MiscellaneousRequestsPage, access: [ADMIN, HOD, HOR, STAFF, PS] },
  { path: "/miscellaneous/requests/add", element: MiscellaneousRequestAddPage, access: [ADMIN, HOD, HOR, STAFF, PS] },
  { path: "/miscellaneous/requests/:id", element: MiscellaneousRequestPage, access: [ADMIN, HOD, HOR, STAFF, PS] },
  { path: "/miscellaneous/requests/:id/survey/:reportHeaderId/certificates", element: MiscellaneousCertificatePage, access: [ADMIN, HOD, HOR, STAFF, PS] },
  {
    path: "/miscellaneous/requests/:id/survey/:reportHeaderId/certificates/prepare-and-amend-cert",
    element: MiscellaneousCertificatePrepareAndAmendPage,
    access: [ADMIN, HOD, HOR, STAFF, PS],
  },
  {
    path: "/miscellaneous/requests/:id/survey/:reportHeaderId/additional-details",
    element: MiscellaneousRequestAdditionalDetailsPage,
    access: [ADMIN, HOD, HOR, STAFF, PS],
  },
  {
    path: "/miscellaneous/requests/:id/survey/:reportHeaderId/survey-reporting/:surveyCategoryId/item-update",
    element: PeriodicalSurveyReportingItemUpdatePage,
    access: [ADMIN, HOD, HOR, STAFF, PS],
  },
  { path: "/ml-item-manage/requests", element: MLItemManageRequestsPage, access: [ADMIN, HOD, HOR, STAFF, PS] },
  { path: "/ml-item-manage/requests/:reportHeaderId", element: MLItemManageRequestPage, access: [ADMIN, HOD, HOR, STAFF, PS, SIC, SURVEYOR] },
];

const deleteShipSurveysRoutes = [
  { path: "/delete-ship-surveys/requests", element: MiscellaneousRequestsPage, access: [ADMIN, HOD, HOR, STAFF] },
  { path: "/delete-ship-surveys/requests/add", element: MiscellaneousRequestAddPage, access: [ADMIN, HOD, HOR, STAFF] },
  { path: "/delete-ship-surveys/requests/:id", element: MiscellaneousRequestPage, access: [ADMIN, HOD, HOR, STAFF] },
];

const extendCocDueDateRoutes = [
  { path: "/extend-coc-due-date/requests", element: ExtendCocDueDateRequestsPage, access: [ADMIN, HOD, HOR, SIC_REG, STAFF] },
  { path: "/extend-coc-due-date/requests/:reportHeaderId", element: ExtendCocDueDateRequestPage, access: [ADMIN, HOD, HOR, SIC_REG, STAFF] },
];

const postponeRoutes = [
  { path: "/survey/postponement-requests", element: MiscellaneousRequestsPage, access: [ADMIN, HOD, HOR, STAFF, SURVEYOR] },
  { path: "/survey/postponement-requests/add", element: MiscellaneousRequestAddPage, access: [ADMIN, HOD, HOR, SURVEYOR] },
  { path: "/survey/postponement-requests/:id", element: MiscellaneousRequestPage, access: [ADMIN, HOD, HOR, STAFF, SURVEYOR] },
  { path: "/survey/postponement-requests/:id/checklist/:reportHeaderId", element: SurveyPostponementChecklistPage, access: [ADMIN, HOD, HOR, SURVEYOR] },
  { path: "/survey/:reportHeaderId/postponement-auth-letter/:id", element: SurveyPostponementAuthletterPage, access: [ADMIN, HOD, HOR, STAFF, SURVEYOR] },
  // { path: "/survey/:reportHeaderId/postponement-digital-auth-letter", element: PrepareDigitalAuthLetter, access: [ADMIN, HOD, HOR, STAFF,SURVEYOR] },
];

const changeOfCyclceRoutes = [
  { path: "/change-survey-cycle", element: ChangeSurveyCycleListPage, access: [ADMIN, HOO, HOD, HOR, SURVEYOR, STAFF], },
  { path: "/change-survey-cycle/add", element: ChangeSurveyCyclePage, access: [ADMIN, HOO, HOD, HOR, SURVEYOR, STAFF], },
  { path: "/change-survey-cycle/:id", element: ChangeSurveyCyclePage, access: [ADMIN, HOO, HOD, HOR, SURVEYOR, STAFF], },
  { path: "/change-survey-type/add", element: ChangeSurveyTypePage, access: [ADMIN, HOO, HOD, HOR, SURVEYOR, STAFF], },
  { path: "/change-survey-type/:id", element: ChangeSurveyTypePage, access: [ADMIN, HOO, HOD, HOR, SURVEYOR, STAFF], },
];

const pR17Routes = [
  { path: "/pr-17/requests", element: ExtendCocDueDateRequestsPage, access: [ADMIN, HOD, HOR, STAFF] },
  { path: "/pr-17/requests/:id/edit", element: PR17EditFormPage, access: [ADMIN, HOD, HOR, STAFF] },
  { path: "/pr-17/requests/add", element: PR17EditFormPage, access: [ADMIN, HOD, HOR, STAFF] },
  { path: "/pr-17/requests/:reportHeaderId/deficiency/:deficiencyId", element: PR17SecurityPage, access: [ADMIN, HOD, HOR, STAFF] },
  { path: "/psc-fsi/requests/add", element: PSCFSIFormPage, access: [ADMIN, HOD, HOR, STAFF] },
  { path: "/psc-fsi/:reportHeaderId/requests/add", element: PSCFSIFormPage, access: [ADMIN, HOD, HOR, STAFF, SURVEYOR] },
];

const deleteOverdueSurveyCategoriesRoutes = [
  { path: "/delete-overdue-survey-categories/requests", element: ExtendCocDueDateRequestsPage, access: [ADMIN, SIC_REG, HOD, HOR, NR, AM, RM] },
  {
    path: "/delete-overdue-survey-categories/requests/:surveyRequestId",
    element: DeleteOverdueSurveyCategoriesRequestPage,
    access: [ADMIN, SIC_REG, HOD, HOR, NR, AM, RM],
  },
];

const revertSurveyStatusRequestsRoutes = [
  { path: "/revert-survey-status-requests/requests", element: ExtendCocDueDateRequestsPage, access: [ADMIN, SIC_REG, HOD, HOR, NR, AM, RM] },
];

const prolongedListingRoutes = [{ path: "/prolonged-listing", element: prolongedListingPage, access: [ADMIN, SIC_REG, HOD, HOR, NR, AM, RM] }];
const updateScopeOfClassReinstatementRoutes = [
  {
    path: "/update-scope-of-class-reinstatement-surveys/requests",
    element: updateScopeOfClassReinstatementSurveysRequestsPage,
    access: [ADMIN, HOO, SIC_REG, HOD, NR, AM, RM, SIC],
  },
];

const ERSRoutes = [
  { path: "/ers/customer-request", element: ERSCustomerRequestPage, access: [HOR, HOD, ADMIN, HOSURVEYOR] },
  { path: "/ers/:irNo/customer-request/:serviceRequestId", access: [HOR, HOD, ADMIN], element: ERSCustomerRequestDetailPage },
  { path: "/ers/my-jobs", element: ERSMyJobsPage, access: [ADMIN, HOD, HOR, SURVEYOR] },
  { path: "/ers/:irNo/my-jobs/:serviceRequestId/prepare-agreement", element: ERSPrepareAgreementPage, access: [ADMIN, HOD, HOR, SURVEYOR] },
  { path: "/ers/:irNo/my-jobs/:serviceRequestId/upload-emails", element: ERSUploadEmailsPage, access: [ADMIN, HOD, HOR, SURVEYOR] },
  { path: "/ers/:irNo/my-jobs/:seviceRequestId/prepare-ft-certificate", element: ERSPrepareFtCertificatePage, access: [ADMIN, HOD, HOR, SURVEYOR] },
  { path: "/ers/:irNo/my-jobs/:serviceRequestId/service-reporting", element: ERSServiceReportingPage, access: [ADMIN, HOD, HOR, SURVEYOR] },
  { path: "/ers/:irNo/my-jobs/:serviceRequestId/service-reporting/:formId", element: ERSReportPreviewPage, access: [ADMIN, HOD, HOR, SURVEYOR] },
  {
    path: "/ers/:irNo/my-jobs/:serviceRequestId/service-reporting/:certificateId/digital-certificate",
    element: ERSPrepareDigitalCertificatePage,
    access: [ADMIN, HOD, HOR, SURVEYOR],
  },
  { path: "/ers/pending-report", element: ERSPendingReportPage, access: [ADMIN, HOD, HOR, HOSURVEYOR] },
  { path: "/ers/certificates", element: ERSCertificatePage, access: [ADMIN, HOD, HOR, HOSURVEYOR] },
  {
    path: "/ers/:irNo/service-request/:serviceRequestId/certificates/:certificateId/full-term",
    element: ERSCertificateDetailPage,
    access: [ADMIN, HOD, HOR, SURVEYOR],
  },
];

const WeldingConsumablesRoutes = [
  { path: "/wc/certificates", element: WCCertificatePage },
  {
    path: "/wc/certificates/:certificateId",
    element: WCCertificateDetailPage,
  },
  {
    path: "/welding-consumables/contract-review",
    element: WCContractReviewPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  {
    path: "/bsa/due-audits",
    element: BSACertificateDuePage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  {
    path: "/welding-consumables/contract-review/:contractReviewId",
    element: WCContractDetailPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  {
    path: "/welding-consumables/contract-review/add",
    element: WCContractDetailPage,
    access: [HOR, SIC, SIC_REG, SURVEYOR, NR, BNK, BNK_STAFF],
  },
  { path: "/audit-request/wc/:companyId", element: WCAuditRequestTAPage, access: [WC_CLIENT] },
  { path: "/audit-request/wc/:companyId/:reportHeaderId/scope/:scopeId", element: WCAuditRequestTAPage, access: [WC_CLIENT] },

  { path: "/wc/pending-allocation", element: WCPendingAllocationPage, access: [SIC, SIC_REG, NR, BSA_QUALIFIED_AUDITOR] },
  { path: "/wc/my-audits", element: WCMyAuditsPage, access: [SURVEYOR] },
  { path: "/wc/my-audits/:contractReviewId/survey-planning", element: WCSurveyPlanningPage, access: [SURVEYOR] },
  { path: "/wc/my-audits/:reportHeaderId/survey-reporting", element: WCSurveyReportingPage, access: [SURVEYOR] },
  { path: "/wc/my-audits/:reportHeaderId/survey-reporting/:formId", element: WCSurveyReportingFormPage, access: [SURVEYOR] },
  {
    path: "/wc/pending-report-review",
    element: WCPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER, NR] },
    access: [SIC, SIC_REG, SS_REVIEWER, NR],
  },

  { path: "/wc/pending-report-audit", element: WCPendingReportPage, elementProps: { pageFor: [ADMIN, HOD, HOR] }, access: [ADMIN, HOD, HOR] },
  { path: "/wc/certificates/:certificateId/prepare-digital", element: WCPrepareDigitalCertificatePage },
];

const FeExistingRoutes = [
  {
    path: "/change-of-flag",
    element: FeExistingListingPage,
    access: [ADMIN, HOD, HOR, STAFF, STS, PS, HOD_HULL, HOD_MACH],
  },
  {
    path: "/change-of-flag/ror/:id/forms",
    element: FEExistingRORMyAuditPageDetails,
    access: [ADMIN, HOD, HOR, STAFF, STS, PS, HOD_HULL, HOD_MACH],
  },
  {
    path: "/remote-survey/ror/:id/forms",
    element: RemoteSurveyPageDetails,
    access: [ADMIN, HOD, HOR, STAFF],
  },
];
const ESPRoutes = [
  { path: "/esp/add-request", element: ESPAddRequestPage, access: [CLIENT, ADMIN, HOD, HOR, ESP] },
  { path: "/esp/edit/:espId", element: ESPEditRequestPage, access: [CLIENT, ADMIN, HOD, HOR, ESP] },
  { path: "/esp-list", element: ESPListPage, access: [CLIENT, ADMIN, HOD, HOR, ESP] },
  {
    path: "/esp/:requestId/authorisation-letter",
    element: ESPAuthorisationLetterPage,
    access: [CLIENT, ADMIN, HOD, HOR, ESP],
  },
  {
    path: "/esp/:letterId/authorisation-letter/prepare",
    element: ESPDigitalLetterPage,
    access: [CLIENT, ADMIN, HOD, HOR, ESP],
  },
];

const MCSRoutes = [
  { path: "/marine-component/customer-request", element: MCSSRFListPage, access: [ADMIN, HOO, HOR, HOD, NR, SIC_REG, SIC, SS_REVIEWER, SURVEYOR, STAFF] },
  { path: "/marine-component/customer-request/add", element: MCSSurveyRequestDetailPage, access: [ADMIN, HOO, HOR, HOD, NR, SIC_REG, SIC, SS_REVIEWER, SURVEYOR, STAFF] },
  { path: "/marine-component/customer-request/:surveyRequestId", element: MCSSurveyRequestDetailPage, access: [ADMIN, HOO, HOR, HOD, NR, SIC_REG, SIC, SS_REVIEWER, SURVEYOR, STAFF] },
  { path: "/marine-component/pending-allocation", element: MCSPendignAllocationPage, access: [SIC, SIC_REG, NR, IA_QUALIFIED_AUDITOR] },
  { path: "/marine-component/my-audits", element: MCSMyAuditsPage, access: [SURVEYOR] },
  { path: "/marine-component/my-audits/:surveyRequestId/survey-planning", element: MCSSurveyPlanningPage, access: [SURVEYOR] },
  {
    path: "/marine-component/my-audits/:reportHeaderId/survey-reporting",
    element: MCSSurveyReportingPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  { path: "/marine-component/my-audits/:reportHeaderId/survey-reporting/:formId", element: MCSSurveyReportingFormPage, access: [SURVEYOR] },
  {
    path: "/marine-component/pending-report-review",
    element: MCSPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  { path: "/marine-component/pending-report-audit", element: MCSPendingReportPage, elementProps: { pageFor: [ADMIN, HOD, HOR] }, access: [HOD, HOR] },
  { path: "/marine-component/certificates", element: MCSCertificatePage },
  { path: "/marine-component/certificates/:certificateId/prepare-digital", element: MCSPrepareDigitalCertificatePage },

  {
    path: "/marine-component/surveyor-qualification",
    element: MCSSurveyorQualificationPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER],
  },
  {
    path: "/marine-component/activity-monitoring",
    element: MCSActivityMonitoringPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/marine-component/activity-monitoring/:activityMonitoringId",
    element: MCSActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/marine-component/activity-monitoring/add",
    element: MCSActivityMonitoringDetailPage,
    access: [ADMIN, HOD, HOR, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/marine-component/my-audits/:reportHeaderId/survey-reporting/ms/:employeeCode",
    element: MCSMSFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/marine-component/my-audits/:reportHeaderId/survey-reporting/ms",
    element: MCSMSFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/marine-component/surveyor-qualification/:employeeCode/approval",
    element: MCSQsFormPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/marine-component/my-audits/:reportHeaderId/survey-reporting/qs/:employeeCode",
    element: MCSQsFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  {
    path: "/marine-component/my-audits/:reportHeaderId/survey-reporting/qs",
    element: MCSQsFormPage,
    access: [ADMIN, HOR, SIC, SURVEYOR],
  },
  { path: "/marine-component/mis-reports", element: MisReportPage },
  {
    path: "/marine-component/mentoring-survey",
    element: MCSMSFormPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/marine-component/qualification-survey",
    element: MCSQsFormPage,
    access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR],
  },
];

const ManageCompaniesRoutes = [
  {
    path: "/manage-companies",
    element: ManageCompaniesListingPage,
    access: (loggedInUser) =>
      loggedInUser.checkAccess([ADMIN]) || loggedInUser?.user?.roles?.some((role) => role?.code === "RMGC"),
  },
  {
    path: "/manage-companies/add",
    element: AddCompanyPage,
    access: (loggedInUser) =>
      loggedInUser.checkAccess([ADMIN]) || loggedInUser?.user?.roles?.some((role) => role?.code === "RMGC"),
  },
  {
    path: "/manage-companies/edit/:companyId",
    element: AddCompanyPage,
    access: (loggedInUser) =>
      loggedInUser.checkAccess([ADMIN]) || loggedInUser?.user?.roles?.some((role) => role?.code === "RMGC"),
  },
];

const ManageMasterRoutes = [{ path: "/manage-masters", element: ManageMasterPage, access: [HOR, HOD, ADMIN, SURVEYOR] }];

const PFSARoutes = [
  {
    path: "pfsa/contract-review/add",
    element: PFSACustomerRequestPage,
    access: [ADMIN, HOR, HOD, PFSA, PFSA_STAFF],
  },
  {
    path: "pfsa/contract-review/:contractReviewId",
    element: PFSACustomerRequestPage,
    access: [ADMIN, HOR, HOD, PFSA, PFSA_STAFF],
  },
  {
    path: "pfsa/contract-review",
    element: PFSAContractReviewPage,
    access: [ADMIN, HOR, HOD, PFSA, PFSA_STAFF],
  },
  {
    path: "pfsa/my-audits",
    element: PFSAMyAuditsPage,
    access: [ADMIN, SURVEYOR, PFSA, PFSA_STAFF],
  },
  {
    path: "pfsa/my-audits/:contractReviewId/survey-planning",
    element: PFSASurveyPlanningPage,
    access: [ADMIN, SURVEYOR, PFSA, PFSA_STAFF],
  },
  {
    path: "pfsa/my-audits/:reportHeaderId/survey-reporting",
    element: PFSASurveyReportingPage,
    access: [ADMIN, HOR, SURVEYOR, PFSA, PFSA_STAFF],
  },
];

const ModificationConvRequestRoutes = [
  {
    path: "/modification-conv-request",
    element: ModificationConvRequestListingPage,
    access: [ADMIN, HOR, HOD, PAC, RCLSHOD, HOD_STAT, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/modification-conv-request/:id",
    element: ModificationConvRequestEditPage,
    access: [ADMIN, HOR, HOD, PAC, RCLSHOD, HOD_STAT, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/icc-pac-clearance-request/:surveyRequestId",
    element: IccPacClearanceRequestEditPage,
    access: [ADMIN, HOR, HOD, PAC, RCLSHOD, HOD_STAT, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/icc-pac-clearance-checklist/:id",
    element: IccPacClearanceChecklistPage,
    access: [ADMIN, HOR, HOD, PAC, RCLSHOD, HOD_STAT, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/pac-exclusion-closure",
    element: PacExclusionReasonClosurePage,
    access: [ADMIN, HOR, HOD, PAC, RCLSHOD, HOD_STAT, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
];

const MonthlyDGReporting = [{ path: "/monthly-dg-reporting", element: MonthlyDGReportingPage, access: [ADMIN, HOD, HOR, SIC] }];

const HighRisksVessels = [{ path: "/high-risk-vessels", element: HighRisksVesselsPage, access: [ADMIN, HOD, HOR, SIC] }];
const PostponementExtentionMonitoring = [
  { path: "/postponement-extension-monitoring", element: PostponementExtentionMonitoringPage, access: [ADMIN, HOD, HOR, SIC, PS] },
];
const InWaterSurvey = [{ path: "/inwater-survey", element: InWaterSurveyPage, access: [ADMIN, HOD, HOR, SIC] }];

const NavyRoutes = [
  {
    path: "/navy/survey-requests",
    element: NavyCustomerRequestPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/navy/survey-requests/add",
    element: NavyCustomerRequestAddPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/navy/survey-requests/:surveyRequestId",
    element: NavyCustomerRequestAddPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/navy/pending-allocation",
    element: NavyPendingAllocationPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/navy/my-audits",
    element: NavyMyAuditsPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/navy/my-audits/:surveyRequestId/survey-planning",
    element: NavySurveyPlanningPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/navy/my-audits/:reportHeaderId/survey-reporting",
    element: NavySurveyReportingPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/navy/my-audits/:reportHeaderId/survey-reporting/:formId",
    element: RefitDetailsFormPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/navy/pending-report-review",
    element: NavyPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/navy/my-audits/:reportHeaderId/survey-reporting/:formId/f003",
    element: NavyForm0003Page,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  { path: "/navy/certificates/:certificateId/prepare-digital", element: NavyReportingPrepareDigitalCertificatePage },
];

const SVRRoutes = [
  {
    path: "/ship-vetting/survey-requests",
    element: SVRSurveyRequestPage,
    access: [HOR, SIC, SURVEYOR, ADMIN],
  },
  {
    path: "/ship-vetting/survey-requests/add",
    element: SVRSurveyRequestFormPage,
    access: [HOR, SIC, SURVEYOR, ADMIN],
  },
  {
    path: "/ship-vetting/survey-requests/:surveyRequestId",
    element: SVRSurveyRequestFormPage,
    access: [HOR, SIC, SURVEYOR, ADMIN],
  },
  {
    path: "/ship-vetting/pending-allocation",
    element: SVRSurveyPendingAllocationPage,
    access: [HOR, SIC, SURVEYOR, ADMIN],
  },
  { path: "/ship-vetting/my-audits", element: SVRMyJobsPage, access: [ADMIN, HOD, HOR, SURVEYOR] },
  {
    path: "/ship-vetting/my-audits/:surveyRequestId/survey-planning",
    element: SVRSurveyPlanningPage,
    access: [ADMIN, SIC, SIC_REG, SURVEYOR],
  },
  {
    path: "/ship-vetting/my-audits/:reportHeaderId/survey-reporting",
    element: SVRSurveyReportingPage,
    access: [ADMIN, SIC_REG, SIC, SURVEYOR, SS_REVIEWER],
  },
  {
    path: "/ship-vetting/my-audits/:reportHeaderId/survey-reporting/:formId",
    element: SVRSurveyReportingFormPage,
    access: [ADMIN, SIC_REG, SIC, SURVEYOR, SS_REVIEWER],
  },
  {
    path: "/ship-vetting/my-audits/:reportHeaderId/survey-reporting/:formId/report",
    element: SVRSurveyReportingReportPage,
    access: [SURVEYOR],
  },
  {
    path: "/ship-vetting/pending-report-review",
    element: SVRPendingReportPage,
    elementProps: { pageFor: [SIC, SIC_REG, SS_REVIEWER, SIC, ADMIN] },
    access: [SIC, SIC_REG, SS_REVIEWER, HOR, SIC, ADMIN],
  },
  {
    path: "/ship-vetting/pending-report-audit",
    element: SVRPendingReportPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
];

const VoyageRoutes = [
  {
    path: "/voyage/survey-request",
    element: SingleVoyageCustomerRequestListPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/voyage/survey-request/add",
    element: SingleVoyageCustomerRequestFormPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/voyage/pending-allocation",
    element: SingleVoyagePendingAllocationPage,
    access: [SIC, SIC_REG, NR, IA_QUALIFIED_AUDITOR],
  },
  {
    path: "/voyage/my-audits",
    element: SingleVoyageMyAuditsPage,
    access: [ADMIN, SIC, SIC_REG, SURVEYOR],
  },
  {
    path: "/voyage/my-audits/:contractReviewId/survey-planning",
    element: SingleVoyageSurveyPlanningPage,
    access: [ADMIN, SIC, SIC_REG, SURVEYOR],
  },
  {
    path: "/voyage/my-audits/:reportHeaderId/survey-reporting",
    element: SingleVoyageSurveyReportingPage,
    access: [ADMIN, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/voyage/my-audits/:reportHeaderId/survey-reporting/:formId",
    element: SingleVoyageSurveyReportingFormPage,
    access: [ADMIN, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/voyage/pending-report-review",
    element: SingleVoyagePendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/voyage/contract-review/:id",
    element: SingleVoyageCustomerRequestDetailsPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
];

const TowingPermissionRoutes = [
  {
    path: "/towing-permission",
    element: TowningPermissionAuditRequestListPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/towing-permission/add",
    element: TowningPermissionAuditRequestFormPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, TP_CLIENT],
  },
  {
    path: "/towing-permission/contract-review/:id",
    element: TowningPermissionAuditRequestFormPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, TP_CLIENT],
  },
  {
    path: "/towing-permission/pending-allocation",
    element: TowingPermissionPendingAllocationPage,
    access: [SIC, SIC_REG, NR, IA_QUALIFIED_AUDITOR],
  },
  {
    path: "/towing-permission/my-audits",
    element: TowingPermissionMyAuditsPage,
    access: [ADMIN, SIC, SIC_REG, SURVEYOR],
  },
  {
    path: "/towing-permission/my-audits/:contractReviewId/survey-planning",
    element: TowingPermissionSurveyPlanningPage,
    access: [ADMIN, SIC, SIC_REG, SURVEYOR],
  },
  {
    path: "/towing-permission/my-audits/:reportHeaderId/survey-reporting",
    element: TowingPermissionSurveyReportingPage,
    access: [ADMIN, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/towing-permission/my-audits/:reportHeaderId/survey-reporting/:formId",
    element: TowingPermissionSurveyReportingFormPage,
    access: [ADMIN, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/towing-permission/pending-report-review",
    element: TowingPermissionPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  { path: "/towing-permission/mis-reports", element: MisReportPage },
];

const MiscellaneousXReportingRoutes = [
  {
    path: "/misc-x-reporting/survey-requests",
    element: MiscXReportingSurveyRequestPage,
    elementProps: { pageFor: [ADMIN, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/misc-x-reporting/survey-requests/add",
    element: MiscXReportingRequestAddPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, MXR_CLIENT],
  },
  {
    path: "/misc-x-reporting/survey-requests/:surveyRequestId",
    element: MiscXReportingRequestAddPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/misc-x-reporting/pending-allocation",
    element: MiscXReportingPendingAllocationPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/misc-x-reporting/my-audits",
    element: MiscXReportingMyAuditsPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/misc-x-reporting/my-audits/:surveyRequestId/survey-planning",
    element: MiscXReportingSurveyPlanningPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/misc-x-reporting/my-audits/:reportHeaderId/survey-reporting",
    element: MiscXReportingSurveyReportingPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/misc-x-reporting/pending-report-audit",
    element: MiscXReportingReportReviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR],
  },
  {
    path: "/misc-x-reporting/pending-report-review",
    element: MiscXReportingReportReviewPage,
    elementProps: { pageFor: [SIC, SIC_REG] },
    access: [ADMIN, SIC, SIC_REG, NR],
  },
  {
    path: "/misc-x-reporting/my-audits/:reportHeaderId/survey-reporting/:formId",
    element: MiscXReportingSurveyReportingFormPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/misc-x-reporting/my-audits/:reportHeaderId/survey-reporting/:formId/f003",
    element: MiscXReportingSurveyForm0003Page,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  { path: "/misc-x-reporting/certificates/:certificateId/prepare-digital", element: MiscXReportingPrepareDigitalCertificatePage },
  { path: "/misc-x-reporting/my-audits/:reportHeaderId/survey-reporting/:formId/report", element: MiscXReportingReportPage, access: [SURVEYOR] },
];

const MtsCapRoutes = [
  {
    path: "/mtscap/survey-requests",
    element: MtsCapSurveyRequestPage,
    elementProps: { pageFor: [ADMIN, RMAS] },
    access: [ADMIN, RMAS],
  },
  {
    path: "/mtscap/survey-requests/add",
    element: MtsCapRequestAddPage,
    access: [ADMIN, RMAS],
  },
  {
    path: "/mtscap/survey-requests/:surveyRequestId/authorisation-letter",
    element: MtsCapAuthorisationLetterPage,
    access: [ADMIN, RMAS],
  },
  {
    path: "/mtscap/survey-requests/:surveyRequestId",
    element: MtsCapRequestAddPage,
    access: [ADMIN, RMAS],
  },
  {
    path: "/mtscap/pending-allocation",
    element: MtsCapPendingAllocationPage,
    access: [ADMIN, RMAS, SIC, SIC_REG, SS_REVIEWER, NR],
  },
  {
    path: "/mtscap/my-audits",
    element: MtsCapMyAuditsPage,
    access: [ADMIN, RMAS, SIC, SIC_REG, SURVEYOR],
  },
  {
    path: "/mtscap/my-audits/:surveyRequestId/survey-planning",
    element: MtsCapSurveyPlanningPage,
    access: [ADMIN, RMAS, SIC, SIC_REG, SURVEYOR],
  },
  {
    path: "/mtscap/my-audits/:reportHeaderId/survey-reporting",
    element: MtsCapSurveyReportingPage,
    access: [ADMIN, RMAS, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, NR],
  },
  {
    path: "/mtscap/pending-report-review",
    element: MtsCapPendingReportPage,
    elementProps: { pageFor: [SIC] },
    access: [ADMIN, RMAS, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/mtscap/pending-report-audit",
    element: MtsCapPendingReportPage,
    elementProps: { pageFor: [HOD] },
    access: [ADMIN, HOD, RMAS],
  },
  {
    path: "/mtscap/pending-examiner-verification",
    element: MtsCapPendingReportPage,
    elementProps: { pageFor: [RMAS] },
    access: [ADMIN, RMAS],
  },
  {
    path: "/mtscap/authorisation-letter-template",
    element: MtsCapAuthorisationLetterTemplatePage,
    access: [ADMIN, RMAS],
  },
  {
    path: "/mtscap/certificates",
    element: MTSCAPCertificatePage,
    access: [ADMIN, RMAS],
  },
  {
    path: "/mtscap/certificates/:certificateId",
    element: MTSCAPCertificateDetailPage,
    access: [ADMIN, RMAS],
  },
  {
    path: "/mtscap/certificates/:certificateId/prepare-digital",
    element: MTSCAPPrepareDigitalCertificatePage,
    access: [ADMIN, RMAS],
  },
];

const DamageHullAnalysisRoutes = [
  {
    path: "/analysis-list",
    element: DamageAanlysisRequestPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR, RNC],
  },
  {
    path: "/analysis-list/damage-hull-analysis/add",
    element: DamageHullAanlysisPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR, RNC],
  },
  {
    path: "/analysis-list/damage-machinery-analysis/add",
    element: DamageMachineryAanlysisPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR, RNC],
  },
  {
    path: "/analysis-list/damage-hull-analysis/:id",
    element: DamageHullAanlysisPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR, RNC],
  },
  {
    path: "/analysis-list/damage-machinery-analysis/:id",
    element: DamageMachineryAanlysisPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, HOR, RNC],
  },
  {
    path: "/analysis-review",
    element: DamageAanlysisReviewPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR] },
    access: [ADMIN, HOD, HOR, RNC],
  },
];

const UtilitiesRoutes = [
  { path: "/utilities/reviewer-performance-monitoring", element: ReviewPerformanceMonitoringPage },
  { path: "/utilities/black-white-gray-flag", element: BlackWhiteGreyFlagPage },
  { path: "/utilities/fe-statutory-documents", element: FEStatutoryDocumentCHKL },
  { path: "/utilities/transfer-class-society", element: TransferClassSociet },
  { path: "/utilities/notations", element: NotationsPage },
  { path: "/utilities/ml-item-templates", element: MlItemTemplatePage },
  { path: "/utilities/audiitor-matrix", element: AuditMatrix },
  { path: "/utilities/process-master", element: ProcessMasterPage },
  { path: "/utilities/manage-field-master", element: ManageFieldMasterPage },
  { path: "/utilities/focus-areas", element: FocusAreaPage },
  { path: "/utilities/machinery-electrical-activities", element: MachineryElectricalOnboardActivities },
  { path: "/utilities/additional-informations", element: AdditionalInformationsPage },
];

const BuildingCertificatesRoutes = [
  {
    path: "/building-certificates/my-audits",
    element: BuildingCertificatesMyAuditsPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/building-certificates/my-audits/add",
    element: BuildingCertificatesSurveyPlanningPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/building-certificates/my-audits/:reportHeaderId/survey-reporting/:formId/clf",
    element: BuildingCertificatesSSClearanceFormPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/building-certificates/my-audits/:reportHeaderId/survey-reporting/:formId/coc",
    element: BuildingCertificatesCOCFormPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/building-certificates/pending-report-review",
    element: BuildingCertificatesPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/building-certificates/pending-ho-clearance",
    element: BuildingCertificatesHoClearancePage,
    elementProps: { pageFor: [ADMIN, HOD, HOR, PAC] },
    access: [ADMIN, PAC],
  },
  {
    path: "/building-certificates/pending-ho-clearance/:surveyRequestId",
    element: BuildingCertificatesHoClearanceFormPage,
    elementProps: { pageFor: [ADMIN, HOD, HOR, PAC] },
    access: [ADMIN, PAC],
  },
  {
    path: "/building-certificates/my-audits/:surveyRequestId/survey-planning",
    element: BuildingCertificatesSurveyPlanningPage,
    access: [ADMIN, SIC, SIC_REG, SS_REVIEWER, SURVEYOR],
  },
  {
    path: "/building-certificates/my-audits/:reportHeaderId/survey-reporting",
    element: BuildingCertificatesSurveyReportingPage,
    access: [ADMIN, SIC, SIC_REG, SS_REVIEWER, SURVEYOR],
  },
  {
    path: "/building-certificates/:certificateId/prepare-digital",
    element: BuildingCertificatesPrepareDigitalPage,
    access: [ADMIN, SIC, SIC_REG, SS_REVIEWER, SURVEYOR],
  },
  {
    path: "/building-certificates/survey-request/add",
    element: BuildingCertificatesSurveyRequestPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/building-certificates/certificates",
    element: BuildingCertificatesListingPage,
    access: [ADMIN, PAC, SIC, SIC_REG, SS_REVIEWER, SURVEYOR],
  },
];

const MaterialTestsRoutes = [
  {
    path: "/mt/my-audits",
    element: MaterialTestMyAuditsPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/mt/my-audits/cr",
    element: MaterialTestMyAuditsPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/mt/my-audits/add",
    element: MaterialTestSurveyPlanningPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/mt/my-audits/:surveyRequestId/edit",
    element: MaterialTestSurveyEditPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/mt/pending-report-review",
    element: MaterialTestPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/mt/my-audits/:surveyRequestId/survey-planning",
    element: MaterialTestSurveyPlanningPage,
    access: [ADMIN, SIC, SIC_REG, SS_REVIEWER, SURVEYOR],
  },
  {
    path: "/mt/my-audits/:reportHeaderId/survey-reporting",
    element: MaterialTestSurveyReportingPage,
    access: [ADMIN, SIC, SIC_REG, SS_REVIEWER, SURVEYOR],
  },
  {
    path: "/mt/my-audits/:reportHeaderId/survey-reporting/:formId/f003",
    element: MaterialTestSurveyForm0003Page,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/mt/my-audits/:reportHeaderId/survey-reporting/:formId",
    element: MaterialTestSurveyReportingFormPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/mt/certificates/:certificateId/prepare-digital",
    element: MaterialTestPrepareDigitalCertificatePage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
];
const SpecificationServicesRoutes = [
  {
    path: "/specser/my-audits",
    element: SpecificationServicesMyAuditsPage,
    elementProps: { pageFor: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER] },
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/specser/my-audits/add",
    element: SpecificationServicesPlanningPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/specser/pending-report-review",
    element: SpecificationServicesPendingReportPage,
    elementProps: { pageFor: [ADMIN, SIC, SIC_REG, SS_REVIEWER] },
    access: [SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/specser/my-audits/:surveyRequestId/survey-planning",
    element: SpecificationServicesPlanningPage,
    access: [ADMIN, SIC, SIC_REG, SS_REVIEWER, SURVEYOR],
  },
  {
    path: "/specser/my-audits/:reportHeaderId/survey-reporting",
    element: SpecificationServicesSurveyReportingPage,
    access: [ADMIN, SIC, SIC_REG, SS_REVIEWER, SURVEYOR],
  },
  {
    path: "/specser/my-audits/:reportHeaderId/survey-reporting/:formId/f003",
    element: SpecificationServicesForm0003Page,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/specser/my-audits/:reportHeaderId/survey-reporting/:formId",
    element: SpecificationServicesReportingFormPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
  {
    path: "/specser/certificates/:certificateId/prepare-digital",
    element: SpecificationServicesPrepareDigitalCertificatePage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER],
  },
];

const InternalAuditsRoutes = [
  {
    path: "/iavc/audit-plans",
    element: AuditPlannerListPage,
    access: [ADMIN, DH_QHSE, QHSE],
  },
  {
    path: "/iavc/audit-plans/add",
    element: AuditPlannerDetailsPage,
    access: [ADMIN, DH_QHSE, QHSE],
  },
  {
    path: "/iavc/audit-plans/:auditPlanId",
    element: AuditPlannerDetailsPage,
    access: [ADMIN, DH_QHSE, QHSE],
  },
  {
    path: "/iavc/my-audits",
    element: InternalAuditsMyAuditsPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, RHR],
  },
  {
    path: "/iavc/my-audits/:auditPlanId/audit-planning",
    element: InternalAuditsPlanningPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, RHR],
  },
  {
    path: "/iavc/my-audits/:auditDetailId/audit-reporting",
    element: InternalAuditsReportingPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, RHR],
  },
  {
    // path: "/iavc/my-audits/:auditPlanId/survey-reporting/:formId/NC",
    path: "/iavc/my-audits/:auditDetailId/audit-reporting/:formId/F3",
    element: InternalAuditsNoObservationPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, RHR],
  },
  {
    path: "/iavc/nc-audits",
    element: InternalAuditsNCAudits,
    access: [QHSE, SIC_REG, SIC, SURVEYOR, SS_REVIEWER, NR, RHR],
  },
  {
    path: "/iavc/my-audits/:auditDetailId/audit-reporting/:formId",
    element: InternalAuditsReportingFormPage,
    access: [ADMIN, NR, SURVEYOR, SIC, SIC_REG, SS_REVIEWER, RHR],
  },
  {
    path: "/iavc/pending-report-review",
    element: InternalAuditsPendingMrReviewPage,
    elementProps: { pageFor: [HOD] },
    access: [ADMIN, HOD, QHSE],
  },
  {
    path: "/iavc/pending-examiner-verification",
    element: InternalAuditsPendingReportPage,
    elementProps: { pageFor: [QHSE, DH_QHSE] },
    access: [ADMIN, DH_QHSE, QHSE],
  },
];

/** * * Routes which are available only after user is logged in */
export default function getPrivateRoutes() {
  return [
    {
      element: RoutesPrivate,
      access: (loggedInUser) =>
        loggedInUser.checkAccess([
          HOR,
          HOO,
          SIC,
          SIC_REG,
          SURVEYOR,
          NR,
          ISM_STAFF,
          ISPS_STAFF,
          MLC_STAFF,
          CLIENT,
          TRAINING,
          HOEXAMINER,
          STAFF,
          ESP,
          ERS,
          PS,
          PAC,
          RMAS,
          QHSE,
          RHR,
        ]) || loggedInUser?.user?.roles?.some((role) => role?.code === "RMGC"),
      children: [
        {
          element: DashboardLayout,
          children: [
            // __NOTE___: CLIENT Access will be removed
            {
              path: "/dashboard",
              element: DashboardPage,
              elementProps: {
                pageFor: [
                  ISM,
                  ISPS,
                  MLC,
                  TAWA,
                  HOEXAMINER,
                  ISM_STAFF,
                  ISPS_STAFF,
                  MLC_STAFF,
                  SIC,
                  SURVEYOR,
                  SIC_REG,
                  HOR,
                  HOD,
                  NR,
                  TRAINING,
                  STAFF,
                  ESP,
                  ERS,
                  PS,
                  PAC,
                  RMAS,
                  QHSE,
                  RHR,
                ],
              },
              access: [
                ISM,
                ISPS,
                MLC,
                ISM_STAFF,
                ISPS_STAFF,
                MLC_STAFF,
                SIC,
                SURVEYOR,
                SIC_REG,
                HOR,
                HOD,
                NR,
                TRAINING,
                HOEXAMINER,
                STAFF,
                ESP,
                ERS,
                PS,
                PAC,
                RMAS,
                RHR,
              ],
            },
            { path: "/daily-work-log", element: DailyWorkLogPage, access: [ADMIN, HOD, HOR, SIC, SIC_REG, SURVEYOR, SS_REVIEWER, NR] },
            { path: "/ships", element: ShipsPage },
            { path: "/view-reports/:module", element: SurveyHistoryPage },
            { path: "/view-reports", element: ViewReportsPage },
            { path: "/mis-custome-report", element: MISReportingCustome, access: [ADMIN] },
            { path: "/companies-registration", element: CustomerRegisterationPage },
            { path: "/companies-registration/:registrationId/detail", element: CustomerRegistrationDetailPage },
            { path: "/companies-registration/detail", element: CustomerRegistrationDetailPage },
            { path: "/help", element: HelpPage },
            {
              path: "/add-non-class-vessel/:module",
              element: AddNonClassVesselPage,
            },
            ...shipDetailsRoutes,
            ...IARoutes,
            ...feRoutes,
            ...TAWARoutes,
            ...RPSRoutes,
            ...SSARoutes,
            ...BSARoutes,
            ...ShipInspectionRoutes,
            ...PCSRoutes,
            ...PeriodicalSurveyRoutes,
            ...FirstEntryExistingSurveyRoutes,
            ...NewConstructionSurveyRoutes,
            ...RequestFormsRoutes,
            ...miscellaneousRoutes,
            ...deleteShipSurveysRoutes,
            ...extendCocDueDateRoutes,
            ...postponeRoutes,
            ...SRFARoutes,
            ...pR17Routes,
            ...IHMRoutes,
            ...ERSRoutes,
            ...deleteOverdueSurveyCategoriesRoutes,
            ...revertSurveyStatusRequestsRoutes,
            ...WeldingConsumablesRoutes,
            ...FeExistingRoutes,
            ...ESPRoutes,
            ...MCSRoutes,
            ...ManageCompaniesRoutes,
            ...ManageMasterRoutes,
            ...PFSARoutes,
            ...prolongedListingRoutes,
            ...updateScopeOfClassReinstatementRoutes,
            ...ModificationConvRequestRoutes,
            ...MonthlyDGReporting,
            ...HighRisksVessels,
            ...PostponementExtentionMonitoring,
            ...changeOfCyclceRoutes,
            ...NavyRoutes,
            ...VoyageRoutes,
            ...SVRRoutes,
            ...InWaterSurvey,
            ...TowingPermissionRoutes,
            ...BuildingCertificatesRoutes,
            ...UtilitiesRoutes,
            ...MiscellaneousXReportingRoutes,
            ...DamageHullAnalysisRoutes,
            ...MaterialTestsRoutes,
            ...MtsCapRoutes,
            ...SpecificationServicesRoutes,
            ...InternalAuditsRoutes,
          ],
        },
      ],
    },
  ];
}
